// parent.js - CORRECTED IMPORTS with named exports
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Navbar from '../components/Navbar';
import * as parentService from "../services/parentService";

// Import components
import ChildLearningAnalytics from '../components/learning/ChildLearningAnalytics';
import AIPredictionCard from '../components/learning/AIPredictionCard';
import StudyPlanGenerator from '../components/learning/StudyPlanGenerator';
import LoadingSpinner from '../components/common/LoadingSpinner';
import EmptyState from '../components/common/EmptyState';

// Import services with NAMED exports (not default)
import {
  fetchWallet,
  fetchTransactions,
  fetchMonthlyInvoices,
  fetchTeachers,
  fetchHiringRequests,
  fetchChildren,
  fetchChildPrediction,
  // fetchStudyPlans,
  registerChild,
  generateAiPrediction,
  generateStudyPlan,
  processPayment,
  hireTeacher,
  cancelHiringRequest,
  calculateMonthlyPayment,
  supportStudent,
  getChildrenForSupport,
  getDonationHistory,
  supportExamFee,
  getExamFeeStats,
  verifyPayment
} from '../services/parentService';

import {
  getChildLearningProfile
} from '../services/learningAnalyticsService';

function Parent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [teachers, setTeachers] = useState([]);
  const [hiringRequests, setHiringRequests] = useState([]);
  const [children, setChildren] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [tokenBalance, setTokenBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [monthlyInvoices, setMonthlyInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const hasLoaded = useRef(false);
  // Learning Analytics States
  const [selectedChildForAnalytics, setSelectedChildForAnalytics] = useState(null);
  const [childLearningProfile, setChildLearningProfile] = useState(null);
  const [aiPredictions, setAiPredictions] = useState([]);
  const [studyPlans, setStudyPlans] = useState([]);
  const [generatingPrediction, setGeneratingPrediction] = useState(false);
  const [generatingStudyPlan, setGeneratingStudyPlan] = useState(false);
  
  // Add this with your other state variables
  const [currentAiPrediction, setCurrentAiPrediction] = useState(null);
  
  // Modals
  const [showChildModal, setShowChildModal] = useState(false);
  const [showHireModal, setShowHireModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showFundingModal, setShowFundingModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showExamSupportModal, setShowExamSupportModal] = useState(false);
  const [showLearningAnalyticsModal, setShowLearningAnalyticsModal] = useState(false);
  const [showAIPredictionModal, setShowAIPredictionModal] = useState(false);
  const [showStudyPlanModal, setShowStudyPlanModal] = useState(false);
  const [coinAmount, setCoinAmount] = useState("");
  const [showBuyCoinsModal, setShowBuyCoinsModal] = useState(false);

  
  // Payment states
  const [paymentCalculation, setPaymentCalculation] = useState({
    hourlyRate: 0,
    sessionsPerWeek: 0,
    daysPerWeek: 0,
    sessionDuration: 0,
    estimatedMonthlyHours: 0,
    estimatedMonthlyCost: 0,
    teacherName: '',
    childName: '',
    subject: ''
  });
  
  const [selectedHiringRequest, setSelectedHiringRequest] = useState(null);
  const [childrenForSupport, setChildrenForSupport] = useState([]);
  const [donationHistory, setDonationHistory] = useState([]);
  const [examFeeStats, setExamFeeStats] = useState({
    totalSupported: 0,
    waecSupported: 0,
    necoSupported: 0,
    jambSupported: 0,
    otherSupported: 0
  });
  
  // Forms
  const [childForm, setChildForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    grade: '',
    dateOfBirth: '',
    school: '',
    learningGoals: '',
    learningStyle: 'visual',
    subjects: [],
    preferredLearningTimes: []
  });
  
  const [hireForm, setHireForm] = useState({
    teacherId: '',
    childId: '',
    subject: '',
    hourlyRate: '',
    sessionType: 'online',
    preferredDays: [],
    preferredTime: 'afternoon',
    sessionDuration: '60',
    sessionsPerWeek: 1
  });
  
  const [fundingForm, setFundingForm] = useState({
    amount: '',
    currency: 'naira',
    paymentMethod: 'bank_transfer'
  });
  
  const [paymentForm, setPaymentForm] = useState({
    email: '',
    firstName: '',
    lastName: ''
  });
  
  const [supportForm, setSupportForm] = useState({
    childId: '',
    amount: '',
    message: '',
    paymentMethod: 'wallet'
  });
  
  const [examSupportForm, setExamSupportForm] = useState({
    supportType: 'waec',
    numberOfStudents: 1,
    specificChildId: '',
    customAmount: '',
    otherDescription: '',
    message: '',
    paymentMethod: 'wallet'
  });

  const [wallet, setWallet] = useState({
  eduCoins: 0
});
  
  // AI Prediction Form
  const [aiPredictionForm, setAiPredictionForm] = useState({
    childId: '',
    includeObservations: true,
    includePerformanceHistory: true,
    timeframe: '3_months'
  });
  
  // Study Plan Form
  const [studyPlanForm, setStudyPlanForm] = useState({
    childId: '',
    subject: '',
    goals: '',
    timeAvailable: '5 hours per week',
    duration: '4_weeks'
  });
  

const handleBuyCoins = async () => {
  try {
    if (!coinAmount || coinAmount <= 0) {
      return alert("Enter valid amount");
    }

    const res = await parentService.buyCoins(parentId, coinAmount);

    alert(`✅ You received ${res.coins} EduCoins`);

    // 🔄 update UI instantly
    setWallet(prev => ({
      ...prev,
      eduCoins: (prev?.eduCoins || 0) + res.coins
    }));

  } catch (err) {
    alert(err.message);
  }
};
  
  // Email search state variables
  const [teacherEmailSearch, setTeacherEmailSearch] = useState('');
  const [searchingByEmail, setSearchingByEmail] = useState(false);
  
  // Nigerian states and LGAs data (kept as is - static data)
  const nigerianStatesWithLGA = {
    'Abia': ['Aba North', 'Aba South', 'Arochukwu', 'Bende', 'Ikawuno', 'Ikwuano', 'Isiala Ngwa North', 'Isiala Ngwa South', 'Isuikwuato', 'Umu Nneochi', 'Obi Ngwa', 'Ohafia', 'Osisioma Ngwa', 'Ugwunagbo', 'Ukwa East', 'Ukwa West', 'Umuahia North', 'Umuahia South'],
    'Adamawa': ['Demsa', 'Fufore', 'Ganye', 'Girei', 'Gombi', 'Guyuk', 'Hong', 'Jada', 'Lamurde', 'Madagali', 'Maiha', 'Mayo Belwa', 'Michika', 'Mubi North', 'Mubi South', 'Numan', 'Shelleng', 'Song', 'Toungo', 'Yola North', 'Yola South'],
    'Akwa Ibom': ['Abak', 'Eastern Obolo', 'Eket', 'Esit Eket', 'Essien Udim', 'Etim Ekpo', 'Etinan', 'Ibeno', 'Ibesikpo Asutan', 'Ibiono-Ibom', 'Ikot Abasi', 'Ikot Ekpene', 'Ini', 'Itu', 'Mbo', 'Mkpat-Enin', 'Nsit-Atai', 'Nsit-Ibom', 'Nsit-Ubium', 'Obot Akara', 'Okobo', 'Onna', 'Oron', 'Oruk Anam', 'Udung-Uko', 'Ukanafun', 'Uruan', 'Urue-Offong/Oruko', 'Uyo'],
    'Anambra': ['Aguata', 'Anambra East', 'Anambra West', 'Anaocha', 'Awka North', 'Awka South', 'Ayamelum', 'Dunukofia', 'Ekwusigo', 'Idemili North', 'Idemili South', 'Ihiala', 'Njikoka', 'Nnewi North', 'Nnewi South', 'Ogbaru', 'Onitsha North', 'Onitsha South', 'Orumba North', 'Orumba South', 'Oyi'],
    'Bauchi': ['Alkaleri', 'Bauchi', 'Bogoro', 'Damban', 'Darazo', 'Dass', 'Gamawa', 'Ganjuwa', 'Giade', 'Itas/Gadau', 'Jama\'are', 'Katagum', 'Kirfi', 'Misau', 'Ningi', 'Shira', 'Tafawa Balewa', 'Toro', 'Warji', 'Zaki'],
    'Bayelsa': ['Brass', 'Ekeremor', 'Kolokuma/Opokuma', 'Nembe', 'Ogbia', 'Sagbama', 'Southern Ijaw', 'Yenagoa'],
    'Benue': ['Ado', 'Agatu', 'Apa', 'Buruku', 'Gboko', 'Guma', 'Gwer East', 'Gwer West', 'Katsina-Ala', 'Konshisha', 'Kwande', 'Logo', 'Makurdi', 'Obi', 'Ogbadibo', 'Ohimini', 'Oju', 'Okpokwu', 'Otukpo', 'Tarka', 'Ukum', 'Ushongo', 'Vandeikya'],
    'Borno': ['Abadam', 'Askira/Uba', 'Bama', 'Bayo', 'Biu', 'Chibok', 'Damboa', 'Dikwa', 'Gubio', 'Guzamala', 'Gwoza', 'Hawul', 'Jere', 'Kaga', 'Kala/Balge', 'Konduga', 'Kukawa', 'Kwaya Kusar', 'Mafa', 'Magumeri', 'Maiduguri', 'Marte', 'Mobbar', 'Monguno', 'Ngala', 'Nganzai', 'Shani'],
    'Cross River': ['Abi', 'Akamkpa', 'Akpabuyo', 'Bakassi', 'Bekwarra', 'Biase', 'Boki', 'Calabar Municipal', 'Calabar South', 'Etung', 'Ikom', 'Obanliku', 'Obubra', 'Obudu', 'Odukpani', 'Ogoja', 'Yakuur', 'Yala'],
    'Delta': ['Aniocha North', 'Aniocha South', 'Bomadi', 'Burutu', 'Ethiope East', 'Ethiope West', 'Ika North East', 'Ika South', 'Isoko North', 'Isoko South', 'Ndokwa East', 'Ndokwa West', 'Okpe', 'Oshimili North', 'Oshimili South', 'Patani', 'Sapele', 'Udu', 'Ughelli North', 'Ughelli South', 'Ukwuani', 'Uvwie', 'Warri North', 'Warri South', 'Warri South West'],
    'Ebonyi': ['Abakaliki', 'Afikpo North', 'Afikpo South', 'Ebonyi', 'Ezza North', 'Ezza South', 'Ikwo', 'Ishielu', 'Ivo', 'Izzi', 'Ohaozara', 'Ohaukwu', 'Onicha'],
    'Edo': ['Akoko-Edo', 'Egor', 'Esan Central', 'Esan North-East', 'Esan South-East', 'Esan West', 'Etsako Central', 'Etsako East', 'Etsako West', 'Igueben', 'Ikpoba-Okha', 'Oredo', 'Orhionmwon', 'Ovia North-East', 'Ovia South-West', 'Owan East', 'Owan West', 'Uhunmwonde'],
    'Ekiti': ['Ado Ekiti', 'Efon', 'Ekiti East', 'Ekiti South-West', 'Ekiti West', 'Emure', 'Gbonyin', 'Ido-Osi', 'Ijero', 'Ikere', 'Ikole', 'Ilejemeje', 'Irepodun/Ifelodun', 'Ise/Orun', 'Moba', 'Oye'],
    'Enugu': ['Aninri', 'Awgu', 'Enugu East', 'Enugu North', 'Enugu South', 'Ezeagu', 'Igbo Etiti', 'Igbo Eze North', 'Igbo Eze South', 'Isi Uzo', 'Nkanu East', 'Nkanu West', 'Nsukka', 'Oji River', 'Udenu', 'Udi', 'Uzo Uwani'],
    'FCT Abuja': ['Abaji', 'Bwari', 'Gwagwalada', 'Kuje', 'Kwali', 'Municipal Area Council'],
    'Gombe': ['Akko', 'Balanga', 'Billiri', 'Dukku', 'Funakaye', 'Gombe', 'Kaltungo', 'Kwami', 'Nafada', 'Shongom', 'Yamaltu/Deba'],
    'Imo': ['Aboh Mbaise', 'Ahiazu Mbaise', 'Ehime Mbano', 'Ezinihitte', 'Ideato North', 'Ideato South', 'Ihitte/Uboma', 'Ikeduru', 'Isiala Mbano', 'Isu', 'Mbaitoli', 'Ngor Okpala', 'Njaba', 'Nkwerre', 'Nwangele', 'Obowo', 'Oguta', 'Ohaji/Egbema', 'Okigwe', 'Orlu', 'Orsu', 'Oru East', 'Oru West', 'Owerri Municipal', 'Owerri North', 'Owerri West', 'Unuimo'],
    'Jigawa': ['Auyo', 'Babura', 'Biriniwa', 'Birnin Kudu', 'Buji', 'Dutse', 'Gagarawa', 'Garki', 'Gumel', 'Guri', 'Gwaram', 'Gwiwa', 'Hadejia', 'Jahun', 'Kafin Hausa', 'Kazaure', 'Kiri Kasama', 'Kiyawa', 'Kaugama', 'Maigatari', 'Malam Madori', 'Miga', 'Ringim', 'Roni', 'Sule Tankarkar', 'Taura', 'Yankwashi'],
    'Kaduna': ['Birnin Gwari', 'Chikun', 'Giwa', 'Igabi', 'Ikara', 'Jaba', 'Jema\'a', 'Kachia', 'Kaduna North', 'Kaduna South', 'Kagarko', 'Kajuru', 'Kaura', 'Kauru', 'Kubau', 'Kudan', 'Lere', 'Makarfi', 'Sabon Gari', 'Sanga', 'Soba', 'Zangon Kataf', 'Zaria'],
    'Kano': ['Ajingi', 'Albasu', 'Bagwai', 'Bebeji', 'Bichi', 'Bunkure', 'Dala', 'Dambatta', 'Dawakin Kudu', 'Dawakin Tofa', 'Doguwa', 'Fagge', 'Gabasawa', 'Garko', 'Garun Mallam', 'Gaya', 'Gezawa', 'Gwale', 'Gwarzo', 'Kabo', 'Kano Municipal', 'Karaye', 'Kibiya', 'Kiru', 'Kumbotso', 'Kunchi', 'Kura', 'Madobi', 'Makoda', 'Minjibir', 'Nasarawa', 'Rano', 'Rimin Gado', 'Rogo', 'Shanono', 'Sumaila', 'Takai', 'Tarauni', 'Tofa', 'Tsanyawa', 'Tudun Wada', 'Ungogo', 'Warawa', 'Wudil'],
    'Katsina': ['Bakori', 'Batagarawa', 'Batsari', 'Baure', 'Bindawa', 'Charanchi', 'Dandume', 'Danja', 'Dan Musa', 'Daura', 'Dutsi', 'Dutsin Ma', 'Faskari', 'Funtua', 'Ingawa', 'Jibia', 'Kafur', 'Kaita', 'Kankara', 'Kankia', 'Katsina', 'Kurfi', 'Kusada', 'Mai\'Adua', 'Malumfashi', 'Mani', 'Mashi', 'Matazu', 'Musawa', 'Rimi', 'Sabuwa', 'Safana', 'Sandamu', 'Zango'],
    'Kebbi': ['Aleiro', 'Arewa Dandi', 'Argungu', 'Augie', 'Bagudo', 'Birnin Kebbi', 'Bunza', 'Dandi', 'Fakai', 'Gwandu', 'Jega', 'Kalgo', 'Koko/Besse', 'Maiyama', 'Ngaski', 'Sakaba', 'Shanga', 'Suru', 'Wasagu/Danko', 'Yauri', 'Zuru'],
    'Kogi': ['Adavi', 'Ajaokuta', 'Ankpa', 'Bassa', 'Dekina', 'Ibaji', 'Idah', 'Igalamela Odolu', 'Ijumu', 'Kabba/Bunu', 'Kogi', 'Lokoja', 'Mopa Muro', 'Ofu', 'Ogori/Magongo', 'Okehi', 'Okene', 'Olamaboro', 'Omala', 'Yagba East', 'Yagba West'],
    'Kwara': ['Asa', 'Baruten', 'Edu', 'Ekiti', 'Ifelodun', 'Ilorin East', 'Ilorin South', 'Ilorin West', 'Irepodun', 'Isin', 'Kaiama', 'Moro', 'Offa', 'Oke Ero', 'Oyun', 'Pategi'],
    'Lagos': ['Agege', 'Ajeromi-Ifelodun', 'Alimosho', 'Amuwo-Odofin', 'Apapa', 'Badagry', 'Epe', 'Eti-Osa', 'Ibeju-Lekki', 'Ifako-Ijaiye', 'Ikeja', 'Ikorodu', 'Kosofe', 'Lagos Island', 'Lagos Mainland', 'Mushin', 'Ojo', 'Oshodi-Isolo', 'Shomolu', 'Surulere'],
    'Nasarawa': ['Akwanga', 'Awe', 'Doma', 'Karu', 'Keana', 'Keffi', 'Kokona', 'Lafia', 'Nasarawa', 'Nasarawa Egon', 'Obi', 'Toto', 'Wamba'],
    'Niger': ['Agaie', 'Agwara', 'Bida', 'Borgu', 'Bosso', 'Chanchaga', 'Edati', 'Gbako', 'Gurara', 'Katcha', 'Kontagora', 'Lapai', 'Lavun', 'Magama', 'Mariga', 'Mashegu', 'Mokwa', 'Moya', 'Paikoro', 'Rafi', 'Rijau', 'Shiroro', 'Suleja', 'Tafa', 'Wushishi'],
    'Ogun': ['Abeokuta North', 'Abeokuta South', 'Ado-Odo/Ota', 'Egbado North', 'Egbado South', 'Ewekoro', 'Ifo', 'Ijebu East', 'Ijebu North', 'Ijebu North East', 'Ijebu Ode', 'Ikenne', 'Imeko Afon', 'Ipokia', 'Obafemi Owode', 'Odeda', 'Odogbolu', 'Ogun Waterside', 'Remo North', 'Sagamu'],
    'Ondo': ['Akoko North-East', 'Akoko North-West', 'Akoko South-East', 'Akoko South-West', 'Akure North', 'Akure South', 'Ese Odo', 'Idanre', 'Ifedore', 'Ilaje', 'Ile Oluji/Okeigbo', 'Irele', 'Odigbo', 'Okitipupa', 'Ondo East', 'Ondo West', 'Ose', 'Owo'],
    'Osun': ['Aiyedaade', 'Aiyedire', 'Atakunmosa East', 'Atakunmosa West', 'Boluwaduro', 'Boripe', 'Ede North', 'Ede South', 'Egbedore', 'Ejigbo', 'Ife Central', 'Ife East', 'Ife North', 'Ife South', 'Ifedayo', 'Ifelodun', 'Ila', 'Ilesa East', 'Ilesa West', 'Irepodun', 'Irewole', 'Isokan', 'Iwo', 'Obokun', 'Odo Otin', 'Ola Oluwa', 'Olorunda', 'Oriade', 'Orolu', 'Osogbo'],
    'Oyo': ['Afijio', 'Akinyele', 'Atiba', 'Atisbo', 'Egbeda', 'Ibadan North', 'Ibadan North-East', 'Ibadan North-West', 'Ibadan South-East', 'Ibadan South-West', 'Ibarapa Central', 'Ibarapa East', 'Ibarapa North', 'Ido', 'Irepo', 'Iseyin', 'Itesiwaju', 'Iwajowa', 'Kajola', 'Lagelu', 'Ogbomosho North', 'Ogbomosho South', 'Ogo Oluwa', 'Olorunsogo', 'Oluyole', 'Ona Ara', 'Orelope', 'Ori Ire', 'Oyo East', 'Oyo West', 'Saki East', 'Saki West', 'Surulere'],
    'Plateau': ['Barkin Ladi', 'Bassa', 'Bokkos', 'Jos East', 'Jos North', 'Jos South', 'Kanam', 'Kanke', 'Langtang North', 'Langtang South', 'Mangu', 'Mikang', 'Pankshin', 'Qua\'an Pan', 'Riyom', 'Shendam', 'Wase'],
    'Rivers': ['Abua/Odual', 'Ahoada East', 'Ahoada West', 'Akuku-Toru', 'Andoni', 'Asari-Toru', 'Bonny', 'Degema', 'Eleme', 'Emohua', 'Etche', 'Gokana', 'Ikwerre', 'Khana', 'Obio/Akpor', 'Ogba/Egbema/Ndoni', 'Ogu/Bolo', 'Okrika', 'Omuma', 'Opobo/Nkoro', 'Oyigbo', 'Port Harcourt', 'Tai'],
    'Sokoto': ['Binji', 'Bodinga', 'Dange Shuni', 'Gada', 'Goronyo', 'Gudu', 'Gwadabawa', 'Illela', 'Isa', 'Kebbe', 'Kware', 'Rabah', 'Sabon Birni', 'Shagari', 'Silame', 'Sokoto North', 'Sokoto South', 'Tambuwal', 'Tangaza', 'Tureta', 'Wamako', 'Wurno', 'Yabo'],
    'Taraba': ['Ardo Kola', 'Bali', 'Donga', 'Gashaka', 'Gassol', 'Ibi', 'Jalingo', 'Karim Lamido', 'Kumi', 'Lau', 'Sardauna', 'Takum', 'Ussa', 'Wukari', 'Yorro', 'Zing'],
    'Yobe': ['Bade', 'Bursari', 'Damaturu', 'Fika', 'Fune', 'Geidam', 'Gujba', 'Gulani', 'Jakusko', 'Karasuwa', 'Machina', 'Nangere', 'Nguru', 'Potiskum', 'Tarmuwa', 'Yunusari', 'Yusufari'],
    'Zamfara': ['Anka', 'Bakura', 'Birnin Magaji/Kiyaw', 'Bukkuyum', 'Bungudu', 'Gummi', 'Gusau', 'Kaura Namoda', 'Maradun', 'Maru', 'Shinkafi', 'Talata Mafara', 'Chafe', 'Zurmi']
  };
    
  const statesList = Object.keys(nigerianStatesWithLGA).sort();
  
  const [locationFilters, setLocationFilters] = useState({
    state: '',
    localGovernment: ''
  });
  
  const parentId = localStorage.getItem('userId');
  const parentName = localStorage.getItem('userName');
  const parentEmail = localStorage.getItem('userEmail') || '';
  
  // Paystack public key (kept as is)
  const PAYSTACK_PUBLIC_KEY = 'pk_live_a8d3bed218162aa8a0275b669f6b8ed7e6c4a34d';

  // ============ HELPER FUNCTIONS ============
  
  // Format date safely (handles both string dates and timestamp objects)
  const formatDate = (date) => {
    if (!date) return 'N/A';
    
    try {
      // If it's a timestamp object from backend
      if (date.toDate && typeof date.toDate === 'function') {
        return date.toDate().toLocaleDateString();
      }
      // If it's a string or Date object
      return new Date(date).toLocaleDateString();
    } catch (e) {
      return 'Invalid date';
    }
  };

  // Get TRCN Status Display
  const getTRCNDisplay = (teacher) => {
    if (!teacher) return { badgeClass: 'bg-secondary', text: 'No TRCN', icon: 'fa-times-circle' };
    
    // Check if teacher has TRCN number
    if (teacher.trcnNumber && teacher.trcnNumber.trim() !== '') {
      return { 
        badgeClass: 'bg-success', 
        text: 'TRCN Verified', 
        icon: 'fa-check-circle',
        number: teacher.trcnNumber 
      };
    } else {
      return { 
        badgeClass: 'bg-secondary', 
        text: 'No TRCN', 
        icon: 'fa-times-circle' 
      };
    }
  };

  // ============ DATA LOADING ============
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      console.log('Loading data for parent:', parentId);
      
      // ✅ ALL Firestore logic is now in the backend service
    const results = await Promise.allSettled([
  fetchWallet(parentId),
  fetchTransactions(parentId),
  fetchMonthlyInvoices(parentId),
  fetchHiringRequests(parentId),
  fetchChildren(parentId)
]);

const walletData = results[0].status === "fulfilled" ? results[0].value : {};
const transactionsData = results[1].status === "fulfilled" ? results[1].value : [];
const invoicesData = results[2].status === "fulfilled" ? results[2].value : [];
const requestsData = results[3].status === "fulfilled" ? results[3].value : [];
const childrenData = results[4].status === "fulfilled" ? results[4].value?.data || []
    : [];
      
      // Add IDs to children if missing
    const childrenArray = childrenData;

const childrenWithIds = childrenArray.map((child, index) => ({
  ...child,
  id: child.id || `child-${index}`,
  studentId: child.studentId || `child-${index}`
}));

// ✅ THIS WAS MISSING
setChildren(childrenWithIds);

      
      setWalletBalance(
  walletData?.wallet?.naira ||
  walletData?.nairaBalance ||
  0
);

setTokenBalance(
  walletData?.tokenBalance ||
  walletData?.eduCoins ||
  0
);
    setTransactions(transactionsData?.data || transactionsData || []);
setMonthlyInvoices(invoicesData?.data || invoicesData || []);
setHiringRequests(requestsData?.data || requestsData || []);
      
      // Load teachers with filters
     const teachersData = await fetchTeachers({});
setTeachers(teachersData);
      
      // Load AI predictions for each child
      const predictions = [];
   for (const child of childrenWithIds) {

  // ✅ ONLY fetch prediction if child has a teacher
  if (!child.teacherId) continue;

  try {
    let prediction = null;

    try {
      prediction = await loadChildPrediction(child.id);
    } catch (err) {
      console.warn(`No prediction yet for child ${child.id}`);
    }

    if (prediction) {
      predictions.push({ 
        ...prediction, 
        childId: child.id, 
        childName: `${child.firstName} ${child.lastName}` 
      });
    }

  } catch (error) {
    console.error(`Error loading prediction for child ${child.id}:`, error);
  }
}
      setAiPredictions(predictions);
      
    } catch (error) {
      console.error('Error loading data:', error);
      alert(`Error loading data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, [parentId]);

  const loadChildPrediction = async (childId) => {
    try {
      // ✅ ALL Firestore logic is now in the backend service
      return await fetchChildPrediction(childId);
    } catch (error) {
      console.error('Error loading child prediction:', error);
      return null;
    }
  };

  const loadSupportData = async () => {
  try {
    const [childrenRes, donationRes, examStatsRes] = await Promise.all([
      getChildrenForSupport(parentId),
      getDonationHistory(parentId),
      getExamFeeStats(parentId)
    ]);

    setChildrenForSupport(childrenRes);
    setDonationHistory(donationRes);
    setExamFeeStats(examStatsRes);

  } catch (error) {
    console.error(error);
  }
};

  const loadChildLearningProfile = async (childId) => {
    try {
      setLoading(true);
      // ✅ ALL Firestore logic is now in the backend service
      const profile = await getChildLearningProfile(childId);
      setChildLearningProfile(profile);
    } catch (error) {
      console.error('Error loading learning profile:', error);
      alert('Error loading learning profile');
    } finally {
      setLoading(false);
    }
  };

  // const loadStudyPlans = async () => {
  //   try {
  //     // ✅ ALL Firestore logic is now in the backend service
  //     const studyPlansData = await fetchStudyPlans(parentId);
  //     setStudyPlans(studyPlansData);
  //   } catch (error) {
  //     console.error('Error loading study plans:', error);
  //   }
  // };

  // ============ AI FUNCTIONS ============

  const handleGenerateAiPrediction = async () => {
    if (!aiPredictionForm.childId) {
      alert('Please select a child');
      return;
    }

    setGeneratingPrediction(true);
    try {
      const child = children.find(c => c.id === aiPredictionForm.childId);
      
      if (!child) {
        throw new Error('Selected child not found');
      }

      // ✅ ALL Firestore logic is now in the backend service
      const prediction = await generateAiPrediction({
        childId: child.id,
        childName: `${child.firstName} ${child.lastName}`,
        parentId,
        includeObservations: aiPredictionForm.includeObservations,
        includePerformanceHistory: aiPredictionForm.includePerformanceHistory,
        timeframe: aiPredictionForm.timeframe
      });

      // Update state
      const newPrediction = {
        id: prediction.id,
        childId: child.id,
        childName: `${child.firstName} ${child.lastName}`,
        ...prediction.data
      };
      
      setAiPredictions(prev => [newPrediction, ...prev.filter(p => p.childId !== child.id)]);
      setCurrentAiPrediction(newPrediction);

      alert('AI prediction generated successfully!');
      setShowAIPredictionModal(false);
      
    } catch (error) {
      console.error('Error generating AI prediction:', error);
      alert('Error generating AI prediction: ' + error.message);
    } finally {
      setGeneratingPrediction(false);
    }
  };

  const handleGenerateStudyPlan = async () => {
    if (!studyPlanForm.childId || !studyPlanForm.subject) {
      alert('Please select a child and subject');
      return;
    }

    setGeneratingStudyPlan(true);
    try {
      const child = children.find(c => c.id === studyPlanForm.childId);
      
      if (!child) {
        throw new Error('Selected child not found');
      }

      // ✅ ALL Firestore logic is now in the backend service
      const studyPlan = await generateStudyPlan({
        childId: child.id,
        childName: `${child.firstName} ${child.lastName}`,
        subject: studyPlanForm.subject,
        goals: studyPlanForm.goals.split(',').map(g => g.trim()).filter(g => g),
        timeAvailable: studyPlanForm.timeAvailable,
        duration: studyPlanForm.duration,
        parentId
      });

      // Update state
      const newStudyPlan = {
        id: studyPlan.id,
        childId: child.id,
        childName: `${child.firstName} ${child.lastName}`,
        subject: studyPlanForm.subject,
        ...studyPlan.data
      };
      
      setStudyPlans(prev => [newStudyPlan, ...prev]);
      
      alert('Study plan generated successfully!');
      setShowStudyPlanModal(false);
      
    } catch (error) {
      console.error('Error generating study plan:', error);
      alert('Error generating study plan: ' + error.message);
    } finally {
      setGeneratingStudyPlan(false);
    }
  };

  // ============ SERVICE FUNCTION USAGE ============

  const searchTeacherByEmail = async () => {
  try {
    if (!teacherEmailSearch.trim()) return;

    setSearchingByEmail(true);

    // ✅ USE NEW UNIFIED FUNCTION
    const results = await fetchTeachers({
      email: teacherEmailSearch
    });

    // ✅ UPDATE STATE CORRECTLY
    setTeachers(results);

  } catch (error) {
    console.error('❌ Email search error:', error);
  } finally {
    setSearchingByEmail(false);
  }
};

const clearSearch = async () => {
  setTeacherEmailSearch('');

  // reset filters
  setLocationFilters({
    state: '',
    localGovernment: ''
  });

  // reload all teachers
  const teachers = await fetchTeachers({});
  setTeachers(teachers);
};

  const handleCalculateMonthlyPayment = () => {
    const { hourlyRate, sessionsPerWeek, sessionDuration, daysPerWeek } = paymentCalculation;
    
    if (!hourlyRate || !sessionsPerWeek || !sessionDuration) {
      alert('Please fill in all required fields');
      return;
    }

    // ✅ ALL Firestore logic is now in the backend service
    const calculation = calculateMonthlyPayment(
      parseFloat(hourlyRate),
      parseInt(sessionsPerWeek),
      daysPerWeek || parseInt(sessionsPerWeek),
      parseInt(sessionDuration),
      new Date()
    );

    setPaymentCalculation(prev => ({
      ...prev,
      estimatedMonthlyHours: calculation.monthlyHours || 0,
      estimatedMonthlyCost: calculation.monthlyCost || 0
    }));
  };

  const handleProcessPayment = async (requestId, amount, teacherId, childId, subject) => {
    try {
      setLoading(true);
      
      if (walletBalance < amount) {
        alert('Insufficient wallet balance. Please fund your wallet first.');
        setShowFundingModal(true);
        return;
      }

      // ✅ ALL Firestore logic is now in the backend service
      const paymentAmount = await processPayment(
        requestId,
        walletBalance,
        parentId,
        parentName
      );

      if (paymentAmount) {
        alert(`Payment processed successfully! ₦${paymentAmount.toLocaleString()} deducted from your wallet.`);
        setShowPaymentModal(false);
        loadData(); // Refresh data
      }
    } catch (error) {
      console.error('Payment processing error:', error);
      alert('Payment processing error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleHireTeacher = async (e) => {
  
    e.preventDefault();
    setLoading(true);
    try {
      // Prepare hire form data
      const hireData = {
        teacherId: hireForm.teacherId,
        childId: hireForm.childId,
        subject: hireForm.subject,
        hourlyRate: hireForm.hourlyRate,
        sessionType: hireForm.sessionType,
        preferredDays: hireForm.preferredDays,
        preferredTime: hireForm.preferredTime,
        sessionDuration: hireForm.sessionDuration,
        sessionsPerWeek: hireForm.sessionsPerWeek
      };

      // ✅ ALL Firestore logic is now in the backend service
      const monthlyCost = await hireTeacher(
        hireData,
        children,
        teachers,
        hiringRequests,
        parentId,
        parentName
      );

      if (monthlyCost) {
        alert(`Teacher hiring request submitted successfully! Estimated monthly cost: ₦${monthlyCost.toLocaleString()}`);
        setShowHireModal(false);
        setHireForm({
          teacherId: '',
          childId: '',
          subject: '',
          hourlyRate: '',
          sessionType: 'online',
          preferredDays: [],
          preferredTime: 'afternoon',
          sessionDuration: '60',
          sessionsPerWeek: 1
        });
        loadData();
      }
    } catch (error) {
      console.error('Error hiring teacher:', error);
      alert('Error hiring teacher: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelHiringRequest = async (requestId) => {
    if (!window.confirm('Are you sure you want to cancel this hiring request?')) {
      return;
    }

    try {
      // ✅ ALL Firestore logic is now in the backend service
      const result = await cancelHiringRequest(requestId);
      if (result.success) {
        alert('Hiring request cancelled successfully');
        loadData();
      } else {
        alert('Error cancelling request: ' + result.message);
      }
    } catch (error) {
      console.error('Error cancelling hiring request:', error);
      alert('Error cancelling request: ' + error.message);
    }
  };

  const handleSupportStudent = async (e) => {
  e.preventDefault();

  const amountNeeded = Number(supportForm.amount);
  const currentCoins = wallet?.eduCoins || 0;

  // 🚨 CHECK COINS FIRST
  if (currentCoins < amountNeeded) {
    alert("⚠️ You need to buy EduCoins first");

    setShowSupportModal(false);
    setShowBuyCoinsModal(true); // 👈 NEW

    return;
  }

  setLoading(true);

  try {
    const result = await supportStudent(supportForm, parentId, parentName);

    if (result.success) {
      alert('🎉 Support sent successfully');

      const used = Number(supportForm.amount);

      // 🔥 INSTANT UI UPDATE
      setWallet(prev => ({
        ...prev,
        eduCoins: (prev?.eduCoins || 0) - used
      }));

      setShowSupportModal(false);

    } else {
      alert(result.message);
    }

  } catch (error) {
    console.error(error);
    alert(error.message);
  } finally {
    setLoading(false);
  }
};
  const handleSupportExamFee = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      const result = await supportExamFee(examSupportForm, parentId, parentName);
      if (result.success) {
        alert('Exam fee support sent successfully!');
        setShowExamSupportModal(false);
        setExamSupportForm({
          supportType: 'waec',
          numberOfStudents: 1,
          specificChildId: '',
          customAmount: '',
          otherDescription: '',
          message: '',
          paymentMethod: 'wallet'
        });
        loadData();
        loadSupportData();
      } else {
        alert('Error sending exam support: ' + result.message);
      }
    } catch (error) {
      console.error('Error supporting exam fee:', error);
      alert('Error supporting exam fee: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterChild = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await registerChild(childForm, parentId);
      alert('Child registered successfully!');
      setShowChildModal(false);
      setChildForm({
        firstName: '',
        lastName: '',
        email: '',
        grade: '',
        dateOfBirth: '',
        school: '',
        learningGoals: '',
        learningStyle: 'visual',
        subjects: [],
        preferredLearningTimes: []
      });
      loadData();
    } catch (error) {
      console.error('Error registering child:', error);
      alert('Error registering child: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ MODAL HANDLERS ============

  const openAIPredictionModal = (child = null) => {
    if (children.length === 0) {
      alert('Please register a child first');
      setShowChildModal(true);
      return;
    }
    
    setAiPredictionForm(prev => ({
      ...prev,
      childId: child ? child.id : ''
    }));
    setShowAIPredictionModal(true);
  };

  const openStudyPlanModal = (child = null) => {
    if (children.length === 0) {
      alert('Please register a child first');
      setShowChildModal(true);
      return;
    }
    
    setStudyPlanForm(prev => ({
      ...prev,
      childId: child ? child.id : ''
    }));
    setShowStudyPlanModal(true);
  };

  const openLearningAnalyticsModal = (child) => {
    setSelectedChildForAnalytics(child);
    setShowLearningAnalyticsModal(true);
    loadChildLearningProfile(child.id);
  };

  const openTeacherProfile = (teacherId) => {
    window.open(`/teacher-profile/${teacherId}`, '_blank');
  };

  const openExamSupportModal = () => {
    if (children.length === 0) {
      alert('Please register a child first to use exam support');
      setShowChildModal(true);
      return;
    }
    setShowExamSupportModal(true);
  };

  const openPaymentModal = (request) => {
    setSelectedHiringRequest(request);
    setPaymentCalculation({
      hourlyRate: request.hourlyRate || 0,
      sessionsPerWeek: request.sessionsPerWeek || 0,
      daysPerWeek: request.preferredDays?.length || 0,
      sessionDuration: request.sessionDuration || 0,
      estimatedMonthlyHours: 0,
      estimatedMonthlyCost: 0,
      teacherName: request.teacherName || '',
      childName: request.childName || '',
      subject: request.subject || ''
    });
    setShowPaymentModal(true);
  };

  // ============ PAYSTACK FUNCTIONS ============
  const initializePaystack = (email, amount, reference, onSuccess, onClose) => {
    if (window.PaystackPop) {
      const handler = window.PaystackPop.setup({
        key: PAYSTACK_PUBLIC_KEY,
        email: email,
        amount: amount * 100, // Convert to kobo
        currency: 'NGN',
        ref: reference,
        callback: function(response) {
          if (onSuccess) onSuccess(response);
        },
        onClose: function() {
          if (onClose) onClose();
        }
      });
      handler.openIframe();
    } else {
      alert('Payment system is loading. Please try again in a moment.');
    }
  };

  const handleFundWalletViaPaystack = async (e) => {
    e.preventDefault();
    if (!fundingForm.amount || fundingForm.amount <= 0) {
      alert('Please enter a valid amount');
      return;
    }

    const amount = parseFloat(fundingForm.amount);
    const email = parentEmail || paymentForm.email;
    
    if (!email) {
      alert('Please provide your email address');
      return;
    }

    // Generate unique reference
    const reference = 'PAYSTACK_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    initializePaystack(
      email,
      amount,
      reference,
      async (response) => {
        try {
          // ✅ ALL Firestore logic is now in the backend service
          const result = await verifyPayment({
            reference: response.reference,
            amount: amount,
            userId: parentId,
            type: 'wallet_funding'
          });

          if (result.success) {
            alert('Payment successful! Your wallet has been funded.');
            setShowFundingModal(false);
            setFundingForm({ amount: '', currency: 'naira', paymentMethod: 'bank_transfer' });
            loadData(); // Refresh wallet balance
          } else {
            alert('Payment verification failed: ' + result.message);
          }
        } catch (error) {
          console.error('Payment verification error:', error);
          alert('Payment verification error. Please contact support.');
        }
      },
      () => {
        alert('Payment was cancelled.');
      }
    );
  };

  // ============ INITIALIZATION ============
useEffect(() => {
  if (!parentId || hasLoaded.current) return;

  hasLoaded.current = true;

  loadData();
}, [parentId, loadData]);


  return (
    <div>
      <Navbar />
      
     <div 
  className="container mt-4"
  style={{ 
    maxWidth: "1200px",
    paddingLeft: "20px",
    paddingRight: "20px"
  }}
>
        {/* Dashboard Header */}
       <div className="mb-4">

  <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

    {/* LEFT */}
    <div>
      <h4 className="fw-bold mb-1">
        Welcome back,{" "}
        <span style={{ color: "#4f46e5" }}>
          {parentName?.split(' ')[0] || 'Parent'}
        </span>
      </h4>

      <small className="text-muted">
        Manage your children, teachers, and payments
      </small>
    </div>

    {/* RIGHT STATS */}
    <div className="d-flex gap-2 flex-wrap">

      <div 
        className="px-3 py-2 rounded-3"
        style={{ background: "#fef3c7" }}
      >
        <small className="text-muted d-block">EDU Coins</small>
        <strong>{tokenBalance}</strong>
      </div>

      <div 
        className="px-3 py-2 rounded-3"
        style={{ background: "#ecfdf5" }}
      >
        <small className="text-muted d-block">Wallet</small>
        <strong>₦{walletBalance.toLocaleString()}</strong>
      </div>

    </div>

  </div>

</div>

        {/* Quick Stats */}
<div className="row mb-4 g-3">

  {/* CHILDREN */}
  <div className="col-6 col-md-6 col-lg-3">
    <div className="card border-0 shadow-sm rounded-4 h-100">
      <div className="card-body">
        <small className="text-muted">My Children</small>
        <h5 className="fw-bold mt-1">{children.length}</h5>
      </div>
    </div>
  </div>

  {/* ACTIVE TEACHERS */}
  <div className="col-6 col-md-6 col-lg-3">
    <div className="card border-0 shadow-sm rounded-4 h-100">
      <div className="card-body">
        <small className="text-muted">Active Teachers</small>
        <h5 className="fw-bold mt-1">
          {hiringRequests.filter(r => r.status === 'accepted').length}
        </h5>
      </div>
    </div>
  </div>

  {/* AI */}
  <div className="col-6 col-md-6 col-lg-3">
    <div className="card border-0 shadow-sm rounded-4 h-100">
      <div className="card-body">
        <small className="text-muted">AI Insights</small>
        <h5 className="fw-bold mt-1">{aiPredictions.length}</h5>
      </div>
    </div>
  </div>

  {/* SPENDING */}
  <div className="col-6 col-md-6 col-lg-3">
    <div className="card border-0 shadow-sm rounded-4 h-100">
      <div className="card-body">
        <small className="text-muted">Monthly Spending</small>
        <h5 className="fw-bold mt-1">
          ₦{hiringRequests
            .filter(r => r.status === 'accepted')
            .reduce((sum, r) => sum + (r.estimatedMonthlyCost || 0), 0)
            .toLocaleString()}
        </h5>
      </div>
    </div>
  </div>

</div>

        {/* Main Content */}
        <div className="row">
          <div className="col-lg-3">
            {/* Quick Actions Card */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">Quick Actions</h6>
              </div>
              <div className="card-body">
                <div className="d-grid gap-2">
                  <button 
                    className="btn btn-outline-dark btn-sm rounded-3"
                    onClick={() => setShowChildModal(true)}
                    disabled={loading}
                  >
                    <i className="fas fa-plus me-2"></i>Add Child
                  </button>
                  <button 
                    className="btn btn-outline-dark btn-sm rounded-3"
                    onClick={() => setShowHireModal(true)}
                    disabled={loading}
                  >
                    <i className="fas fa-chalkboard-teacher me-2"></i>Hire Teacher
                  </button>
                  <button 
                    className="btn btn-outline-dark btn-sm rounded-3"
                    onClick={() => setShowWalletModal(true)}
                    disabled={loading}
                  >
                    <i className="fas fa-wallet me-2"></i>Manage Wallet
                  </button>
                  <button 
                    className="btn btn-outline-dark btn-sm rounded-3"
                    onClick={() => setShowFundingModal(true)}
                    disabled={loading}
                  >
                    <i className="fas fa-money-bill-wave me-2"></i>Fund Wallet
                  </button>
                  <button 
                    className="btn btn-outline-dark btn-sm rounded-3"
                    onClick={() => openAIPredictionModal()}
                    disabled={loading || children.length === 0}
                  >
                    <i className="fas fa-robot me-2"></i>AI Prediction
                  </button>
                  <button 
                    className="btn btn-secondary btn-block"
                    onClick={() => openStudyPlanModal()}
                    disabled={loading || children.length === 0}
                  >
                    <i className="fas fa-calendar-alt me-2"></i>Study Plan
                  </button>
                  <button 
                    className="btn btn-danger btn-block"
                    onClick={() => openExamSupportModal()}
                    disabled={loading}
                  >
                    <i className="fas fa-graduation-cap me-2"></i>Support Exam Fees
                  </button>
                </div>
              </div>
            </div>

            {/* Children List */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">My Children</h6>
              </div>
              <div className="card-body">
                {children.length === 0 ? (
                  <div className="text-center py-3">
                    <i className="fas fa-child fa-2x text-muted mb-3"></i>
                    <p className="text-muted">No children registered yet</p>
                  </div>
                ) : (
                  <div className="list-group list-group-flush">
                    {children.map((child, index) => (
                      <div key={index} className="list-group-item list-group-item-action">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3"
                                 style={{background: "#eef2ff",color: "#4f46e5"}}>
                              {child.firstName?.charAt(0) || 'C'}
                            </div>
                            <div>
                              <h6 className="mb-0">{child.firstName} {child.lastName}</h6>
                              <small className="text-muted">{child.grade}</small>
                            </div>
                          </div>
                          <div className="dropdown">
                            <button className="btn btn-sm btn-outline-secondary" type="button" 
                                    data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="fas fa-ellipsis-v"></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <button className="dropdown-item" onClick={() => openLearningAnalyticsModal(child)}>
                                  <i className="fas fa-chart-line me-2"></i>Analytics
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item" onClick={() => openAIPredictionModal(child)}>
                                  <i className="fas fa-robot me-2"></i>AI Prediction
                                </button>
                              </li>
                              <li>
                                <button className="dropdown-item" onClick={() => openStudyPlanModal(child)}>
                                  <i className="fas fa-calendar-alt me-2"></i>Study Plan
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* AI Predictions Summary */}
            <div className="card shadow mb-4">
              <div className="card-header py-3 bg-dark text-white">
                <h6 className="m-0 font-weight-bold">
                  <i className="fas fa-robot me-2"></i>AI Insights
                </h6>
              </div>
              <div className="card-body">
                {aiPredictions.length === 0 ? (
                  <div className="text-center py-3">
                    <i className="fas fa-robot fa-2x text-muted mb-3"></i>
                    <p className="text-muted">No AI predictions yet</p>
                    <button 
                      className="btn btn-outline-dark btn-sm"
                      onClick={() => openAIPredictionModal()}
                    >
                      Generate First Prediction
                    </button>
                  </div>
                ) : (
                  <div className="list-group list-group-flush">
                    {aiPredictions.slice(0, 3).map((prediction, index) => (
                      <div key={index} className="list-group-item px-0 py-2">
                        <div className="d-flex justify-content-between align-items-start">
                          <div>
                            <h6 className="mb-1">{prediction.childName}</h6>
                            <small className="text-muted">
                              Predicted Performance: <span className={`badge bg-${prediction.predictedPerformance === 'Excellent' ? 'success' : prediction.predictedPerformance === 'Good' ? 'info' : 'warning'}`}>
                                {prediction.predictedPerformance}
                              </span>
                            </small>
                          </div>
                          <div className="text-end">
                            <small className="text-muted">{prediction.confidenceScore}%</small>
                          </div>
                        </div>
                      </div>
                    ))}
                    <button 
                      className="btn btn-outline-dark btn-sm w-100 mt-2"
                      onClick={() => setActiveTab('learning')}
                    >
                      <i className="fas fa-chart-line me-1"></i>View All Insights
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-lg-9">
            {/* Navigation Tabs */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <ul className="nav nav-pills gap-2">
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'dashboard' ? 'active' : ''}`}
                      onClick={() => setActiveTab('dashboard')}
                    >
                      <i className="fas fa-tachometer-alt me-2"></i>Dashboard
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'learning' ? 'active' : ''}`}
                      onClick={() => setActiveTab('learning')}
                    >
                      <i className="fas fa-brain me-2"></i>Learning Analytics
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'teachers' ? 'active' : ''}`}
                      onClick={() => setActiveTab('teachers')}
                    >
                      <i className="fas fa-chalkboard-teacher me-2"></i>Teachers
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'payments' ? 'active' : ''}`}
                      onClick={() => setActiveTab('payments')}
                    >
                      <i className="fas fa-money-bill-wave me-2"></i>Payments
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'exam-support' ? 'active' : ''}`}
                      onClick={() => setActiveTab('exam-support')}
                    >
                      <i className="fas fa-graduation-cap me-2"></i>Exam Support
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'support' ? 'active' : ''}`}
                      onClick={() => setActiveTab('support')}
                    >
                      <i className="fas fa-hands-helping me-2"></i>General Support
                    </button>
                  </li>
                  <li className="nav-item">
                    <button 
                      className={`nav-link rounded-3 px-3 ${activeTab === 'history' ? 'active' : ''}`}
                      onClick={() => setActiveTab('history')}
                    >
                      <i className="fas fa-history me-2"></i>History
                    </button>
                  </li>
                </ul>
              </div>
              
              <div className="card-body">
                {/* Dashboard Tab */}
                {activeTab === 'dashboard' && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card border-left-primary shadow mb-4">
                        <div className="card-body">
                          <h6 className="font-weight-bold text-primary mb-3">
                            <i className="fas fa-chart-line me-2"></i>Recent Activity
                          </h6>
                          {hiringRequests.length === 0 ? (
                            <div className="text-center py-4">
                              <p className="text-muted">No recent activity</p>
                            </div>
                          ) : (
                            <div className="timeline">
                              {hiringRequests.slice(0, 5).map((request, index) => (
                                <div key={index} className="timeline-item mb-3">
                                  <div className="timeline-marker bg-primary"></div>
                                  <div className="timeline-content">
                                    <h6 className="font-weight-bold">{request.teacherName}</h6>
                                    <p className="text-sm mb-1">
                                      {request.subject} for {request.childName}
                                    </p>
                                    <span className={`badge badge-${request.status === 'accepted' ? 'success' : 'warning'}`}>
                                      {request.status}
                                    </span>
                                    <small className="text-muted d-block mt-1">
                                      {formatDate(request.requestedDate)}
                                    </small>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="card border-left-success shadow mb-4">
                        <div className="card-body">
                          <h6 className="font-weight-bold text-success mb-3">
                            <i className="fas fa-wallet me-2"></i>Wallet Summary
                          </h6>
                          <div className="text-center py-3">
                            <h2 className="text-success">₦{walletBalance.toLocaleString()}</h2>
                            <p className="text-muted">Available Balance</p>
                            <div className="d-grid gap-2 mt-3">
                              <button 
                                className="btn btn-success btn-sm"
                                onClick={() => setShowFundingModal(true)}
                              >
                                <i className="fas fa-plus me-2"></i>Add Funds
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card mb-3">
  <div className="card-body">
    <h5 className="fw-bold">💰 Buy EduCoins</h5>

    <input
      type="number"
      className="form-control mb-2"
      placeholder="Enter amount (₦)"
      value={coinAmount}
      onChange={(e) => setCoinAmount(e.target.value)}
    />

    <button
      className="btn btn-primary w-100"
      onClick={handleBuyCoins}
    >
      Buy Coins
    </button>
  </div>
</div>
                    
                    {/* AI Learning Assistant Card */}
                    <div className="col-12 mt-4">
                      <div className="card shadow mb-4">
                        <div className="card-header bg-info text-white">
                          <h6 className="m-0 font-weight-bold">
                            <i className="fas fa-robot me-2"></i>AI Learning Assistant
                          </h6>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6 mb-3">
                              <button 
                                className="btn btn-outline-info w-100"
                                onClick={() => openAIPredictionModal(selectedChildForAnalytics)}
                                disabled={!selectedChildForAnalytics}
                              >
                                <i className="fas fa-chart-line me-2"></i>
                                Analyze Child's Learning
                              </button>
                            </div>
                            <div className="col-md-6 mb-3">
                              <button 
                                className="btn btn-outline-success w-100"
                                onClick={() => openStudyPlanModal(selectedChildForAnalytics)}
                                disabled={!selectedChildForAnalytics}
                              >
                                <i className="fas fa-calendar-alt me-2"></i>
                                Generate Study Plan
                              </button>
                            </div>
                          </div>
                          
                          {/* Show AI Results */}
                          {currentAiPrediction && (
                            <div className="alert alert-info mt-3">
                              <h6>AI Analysis Results</h6>
                              <p><strong>Predicted Performance:</strong> {currentAiPrediction.predictedPerformance}</p>
                              <p><strong>Confidence:</strong> {currentAiPrediction.confidenceScore}%</p>
                              <div className="row">
                                <div className="col-md-6">
                                  <strong>Strengths:</strong>
                                  <ul>
                                    {currentAiPrediction.strengths && currentAiPrediction.strengths.map((s, i) => (
                                      <li key={i}>{s}</li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="col-md-6">
                                  <strong>Areas to Improve:</strong>
                                  <ul>
                                    {currentAiPrediction.weaknesses && currentAiPrediction.weaknesses.map((w, i) => (
                                      <li key={i}>{w}</li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* AI Insights Section */}
                    <div className="col-12 mt-4">
                      <div className="card border-left-dark shadow">
                        <div className="card-header bg-dark text-white">
                          <h6 className="m-0 font-weight-bold">
                            <i className="fas fa-robot me-2"></i>AI Learning Insights
                          </h6>
                        </div>
                        <div className="card-body">
                          {aiPredictions.length === 0 ? (
                            <div className="text-center py-4">
                              <i className="fas fa-robot fa-3x text-muted mb-3"></i>
                              <h5>No AI Insights Yet</h5>
                              <p className="text-muted mb-4">Generate AI predictions to get personalized learning insights</p>
                              <button 
                                className="btn btn-dark"
                                onClick={() => openAIPredictionModal()}
                              >
                                <i className="fas fa-robot me-2"></i>Generate First Insight
                              </button>
                            </div>
                          ) : (
                            <div className="row">
                              {aiPredictions.slice(0, 3).map((prediction, index) => (
                                <div key={index} className="col-md-4 mb-4">
                                  <AIPredictionCard 
                                    prediction={prediction}
                                    onViewDetails={() => setActiveTab('learning')}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Learning Analytics Tab */}
                {activeTab === 'learning' && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h5 className="font-weight-bold text-gray-800">Learning Analytics & AI Insights</h5>
                        <p className="text-muted mb-0">
                          AI-powered insights into your children's learning patterns and performance
                        </p>
                      </div>
                      <div className="d-flex gap-2">
                        <button 
                          className="btn btn-dark"
                          onClick={() => openAIPredictionModal()}
                        >
                          <i className="fas fa-robot me-2"></i>New AI Prediction
                        </button>
                        <button 
                          className="btn btn-secondary"
                          onClick={() => openStudyPlanModal()}
                        >
                          <i className="fas fa-calendar-alt me-2"></i>New Study Plan
                        </button>
                      </div>
                    </div>
                    
                    {/* Child Selection */}
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <div className="card">
                          <div className="card-header">
                            <h6 className="mb-0">Select Child for Analytics</h6>
                          </div>
                          <div className="card-body">
                            <div className="list-group">
                              {children.map((child, index) => (
                                <button
                                  key={index}
                                  className={`list-group-item list-group-item-action ${selectedChildForAnalytics?.id === child.id ? 'active' : ''}`}
                                  onClick={() => {
                                    setSelectedChildForAnalytics(child);
                                    loadChildLearningProfile(child.id);
                                  }}
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3"
                                         style={{width: '40px', height: '40px'}}>
                                      {child.firstName?.charAt(0) || 'C'}
                                    </div>
                                    <div>
                                      <h6 className="mb-0">{child.firstName} {child.lastName}</h6>
                                      <small className="text-muted">{child.grade}</small>
                                    </div>
                                  </div>
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="card h-100">
                          <div className="card-header">
                            <h6 className="mb-0">Quick Actions</h6>
                          </div>
                          <div className="card-body d-flex flex-column justify-content-center">
                            <div className="d-grid gap-3">
                              <button 
                                className="btn btn-dark"
                                onClick={() => openAIPredictionModal()}
                              >
                                <i className="fas fa-robot me-2"></i>Generate AI Prediction
                              </button>
                              <button 
                                className="btn btn-secondary"
                                onClick={() => openStudyPlanModal()}
                              >
                                <i className="fas fa-calendar-alt me-2"></i>Create Study Plan
                              </button>
                              <button 
                                className="btn btn-info"
                                onClick={() => {
                                  if (selectedChildForAnalytics) {
                                    openLearningAnalyticsModal(selectedChildForAnalytics);
                                  } else {
                                    alert('Please select a child first');
                                  }
                                }}
                              >
                                <i className="fas fa-chart-line me-2"></i>View Detailed Analytics
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Child Learning Analytics Component */}
                    {selectedChildForAnalytics && childLearningProfile && (
                      <ChildLearningAnalytics
                        child={selectedChildForAnalytics}
                        profile={childLearningProfile}
                        onGeneratePrediction={() => openAIPredictionModal(selectedChildForAnalytics)}
                        onGenerateStudyPlan={() => openStudyPlanModal(selectedChildForAnalytics)}
                      />
                    )}
                    
                    {/* AI Predictions Section */}
                    <div className="card shadow mb-4">
                      <div className="card-header bg-dark text-white">
                        <h6 className="m-0 font-weight-bold">
                          <i className="fas fa-robot me-2"></i>AI Predictions
                        </h6>
                      </div>
                      <div className="card-body">
                        {aiPredictions.length === 0 ? (
                          <EmptyState
                            icon="fa-robot"
                            title="No AI Predictions Yet"
                            message="Generate AI predictions to get insights into your child's learning potential"
                            actionText="Generate First Prediction"
                            onAction={() => openAIPredictionModal()}
                          />
                        ) : (
                          <div className="row">
                            {aiPredictions.map((prediction, index) => (
                              <div key={index} className="col-md-6 mb-4">
                                <div className="card h-100">
                                  <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                      <div>
                                        <h6 className="font-weight-bold text-primary">{prediction.childName}</h6>
                                        <small className="text-muted">
                                          Generated: {formatDate(new Date(prediction.generatedAt))}
                                        </small>
                                      </div>
                                      <span className={`badge bg-${
                                        prediction.predictedPerformance === 'Excellent' ? 'success' :
                                        prediction.predictedPerformance === 'Good' ? 'info' :
                                        prediction.predictedPerformance === 'Average' ? 'warning' : 'danger'
                                      }`}>
                                        {prediction.predictedPerformance}
                                      </span>
                                    </div>
                                    
                                    <div className="mb-3">
                                      <p className="mb-2">
                                        <strong>Confidence:</strong> {prediction.confidenceScore}%
                                      </p>
                                      <div className="progress" style={{height: '8px'}}>
                                        <div 
                                          className="progress-bar bg-success" 
                                          role="progressbar" 
                                          style={{width: `${prediction.confidenceScore}%`}}
                                          aria-valuenow={prediction.confidenceScore}
                                          aria-valuemin="0"
                                          aria-valuemax="100"
                                        ></div>
                                      </div>
                                    </div>
                                    
                                    <div className="mb-3">
                                      <strong>Strengths:</strong>
                                      <ul className="list-unstyled mb-0">
                                        {(prediction.strengths || []).slice(0, 2).map((strength, i) => (
                                          <li key={i} className="text-success">
                                            <i className="fas fa-check-circle me-1"></i> {strength}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                    
                                    <button 
                                      className="btn btn-outline-dark btn-sm w-100"
                                      onClick={() => {
                                        setSelectedChildForAnalytics(children.find(c => c.id === prediction.childId));
                                        setShowLearningAnalyticsModal(true);
                                      }}
                                    >
                                      View Full Analysis
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                    
                    {/* Study Plans Section */}
                    <div className="card shadow">
                      <div className="card-header bg-secondary text-white">
                        <h6 className="m-0 font-weight-bold">
                          <i className="fas fa-calendar-alt me-2"></i>Study Plans
                        </h6>
                      </div>
                      <div className="card-body">
                        {studyPlans.length === 0 ? (
                          <EmptyState
                            icon="fa-calendar-alt"
                            title="No Study Plans Yet"
                            message="Create personalized study plans for your children"
                            actionText="Create First Study Plan"
                            onAction={() => openStudyPlanModal()}
                          />
                        ) : (
                          <div className="row">
                            {studyPlans.slice(0, 4).map((plan, index) => (
                              <div key={index} className="col-md-6 mb-4">
                                <div className="card h-100">
                                  <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                      <div>
                                        <h6 className="font-weight-bold">{plan.childName}</h6>
                                        <p className="mb-1 text-muted">
                                          <strong>Subject:</strong> {plan.subject}
                                        </p>
                                        <small className="text-muted">
                                          Created: {formatDate(new Date(plan.createdDate))}
                                        </small>
                                      </div>
                                      <span className="badge bg-info">{plan.duration}</span>
                                    </div>
                                    
                                    <div className="mb-3">
                                      <strong>Learning Objectives:</strong>
                                      <ul className="list-unstyled mb-0">
                                        {(plan.planData?.learningObjectives || []).slice(0, 2).map((obj, i) => (
                                          <li key={i}>
                                            <i className="fas fa-check me-1 text-muted"></i> {obj}
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                    
                                    <div className="mb-3">
                                      <strong>Weekly Schedule:</strong>
                                      <div className="mt-2">
                                        {(plan.planData?.weeklySchedule || []).slice(0, 2).map((day, i) => (
                                          <div key={i} className="d-flex justify-content-between mb-1">
                                            <span>{day.day}</span>
                                            <span className="text-muted">{day.duration}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    
                                    <StudyPlanGenerator
                                      plan={plan}
                                      onEdit={() => {
                                        const child = children.find(c => c.id === plan.childId);
                                        if (child) {
                                          setStudyPlanForm({
                                            childId: child.id,
                                            subject: plan.subject,
                                            goals: '',
                                            timeAvailable: '5 hours per week',
                                            duration: '4_weeks'
                                          });
                                          setShowStudyPlanModal(true);
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Teachers Tab */}
                {activeTab === 'teachers' && (
                  <div>
                    {/* Email Search Section */}
                    <div className="row mb-4">
                      <div className="col-md-8">
                        <div className="d-flex gap-2">
                          <select 
                            className="form-select"
                            value={locationFilters.state}
                            onChange={(e) => setLocationFilters({...locationFilters, state: e.target.value, localGovernment: ''})}
                          >
                            <option value="">All States</option>
                            {statesList.map(state => (
                              <option key={state} value={state}>{state}</option>
                            ))}
                          </select>
                          <select 
                            className="form-select"
                            value={locationFilters.localGovernment}
                            onChange={(e) => setLocationFilters({...locationFilters, localGovernment: e.target.value})}
                            disabled={!locationFilters.state}
                          >
                            <option value="">All LGAs</option>
                            {locationFilters.state && nigerianStatesWithLGA[locationFilters.state]?.map(lga => (
                              <option key={lga} value={lga}>{lga}</option>
                            ))}
                          </select>
                          <button 
                            className="btn btn-primary"
                            onClick={() => loadData()}
                          >
                            <i className="fas fa-filter me-2"></i>Filter
                          </button>
                          <button 
                            className="btn btn-outline-secondary"
                            onClick={clearSearch}
>
                            <i className="fas fa-times"></i>
                            </button>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-body">
                            <h6 className="card-title fw-bold mb-3">
                              <i className="fas fa-envelope me-2"></i>Search Teacher by Email
                            </h6>
                            <div className="input-group mb-3">
                              <input
                                type="email"
                                className="form-control"
                                placeholder="teacher@example.com"
                                value={teacherEmailSearch}
                                onChange={(e) => setTeacherEmailSearch(e.target.value)}
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') searchTeacherByEmail();
                                }}
                              />
                              <button 
                                className="btn btn-outline-primary"
                                onClick={searchTeacherByEmail}
                                disabled={searchingByEmail}
                              >
                                {searchingByEmail ? (
                                  <span className="spinner-border spinner-border-sm me-1"></span>
                                ) : (
                                  <i className="fas fa-search"></i>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {teachers.length === 0 ? (
                      <EmptyState
                        icon="fa-chalkboard-teacher"
                        title="No Teachers Available"
                        message={locationFilters.state ? `No teachers found in ${locationFilters.state}` : "No teachers available at the moment"}
                        actionText="Clear Filters"
                        onAction={() => {
                          setLocationFilters({state: '', localGovernment: ''});
                          loadData();
                        }}
                      />
                    ) : (
                      <div className="row">
                        {teachers.map((teacher, index) => {
                          // Get TRCN status display
                          const trcnDisplay = getTRCNDisplay(teacher);
                          
                          return (
                            <div key={index} className="col-md-4 mb-4">
                              <div className="card h-100 teacher-card">
                                <div className="card-body">
                                  {/* Teacher Header with Profile Link */}
                                  <div className="d-flex align-items-start mb-3">
                                    <div 
                                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3 cursor-pointer"
                                      style={{width: '50px', height: '50px'}}
                                      onClick={() => window.open(teacher.profileLink, '_blank')}
                                      title="View Teacher Profile"
                                    >
                                      {teacher.firstName?.charAt(0) || teacher.name?.charAt(0) || 'T'}
                                    </div>
                                    <div>
                                      <h6 className="font-weight-bold mb-0">
                                        <a 
                                          href={`/teacher-profile/${teacher.id}`} 
                                          target="_blank" 
                                          rel="noopener noreferrer"
                                          className="text-decoration-none text-dark"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            openTeacherProfile(teacher.id);
                                          }}
                                        >
                                          {teacher.firstName} {teacher.lastName} 
                                          <i className="fas fa-external-link-alt ms-2 fa-xs text-primary"></i>
                                        </a>
                                      </h6>
                                      <small className="text-muted d-block">{teacher.qualification || 'Qualified Teacher'}</small>
                                      
                                      {/* TRCN Status Badge */}
                                      <div className="mt-1 d-flex flex-wrap gap-1">
                                        {/* Top Rated */}
                                        {teacher.badges?.includes("top_rated") && (
                                          <span className="badge bg-warning text-dark badge-sm">
                                            🏆 Top Rated
                                          </span>
                                        )}

                                        {/* Rising Star */}
                                        {teacher.badges?.includes("rising_star") && (
                                          <span className="badge bg-danger badge-sm">
                                            🔥 Rising Star
                                          </span>
                                        )}

                                        {/* Platform Verified */}
                                        {teacher.badges?.includes("verified") && (
                                          <span className="badge bg-success badge-sm">
                                            ✅ Verified
                                          </span>
                                        )}

                                        {/* TRCN Badge */}
                                        <span className={`badge ${trcnDisplay.badgeClass} badge-sm`}>
                                          <i className={`fas ${trcnDisplay.icon} me-1`}></i>
                                          {trcnDisplay.text}
                                        </span>

                                        {trcnDisplay.number && (
                                          <small className="text-muted ms-2">
                                            #{trcnDisplay.number}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  
                                  {/* Teacher Information */}
                                  <div className="mb-3">
                                    <small className="text-muted d-block">
                                      <i className="fas fa-map-marker-alt me-1"></i>
                                      {teacher.state || ''}{teacher.localGovernment ? `, ${teacher.localGovernment}` : ''}
                                    </small>
                                    <small className="text-muted d-block">
                                      <i className="fas fa-book me-1"></i>
                                      Subjects: {teacher.subjects?.join(', ') || teacher.searchSubjects?.join(', ') || 'Not specified'}
                                    </small>
                                    <small className="text-muted d-block">
                                      <i className="fas fa-clock me-1"></i>
                                      Experience: {teacher.experienceYears || teacher.experience || '0'} years
                                    </small>
                                    {teacher.rating > 0 && (
                                      <small className="text-muted d-block">
                                        <i className="fas fa-star me-1 text-warning"></i>
                                        Rating: {teacher.rating}/5.0
                                      </small>
                                    )}
                                  </div>
                                  
                                  {/* Action Buttons */}
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                      <span className="font-weight-bold text-primary">
                                        ₦{teacher.hourlyRate?.toLocaleString() || '0'}/hour
                                      </span>
                                    </div>
                                    <div className="d-flex gap-2">
                                      <button 
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => {
                                          setHireForm(prev => ({
                                            ...prev,
                                            teacherId: teacher.id,
                                            teacherName: `${teacher.firstName} ${teacher.lastName}`,
                                            hourlyRate: teacher.hourlyRate || 0
                                          }));
                                          setShowHireModal(true);
                                        }}
                                      >
                                        Hire Now
                                      </button>
                                      <button 
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => window.open(teacher.profileLink, '_blank')}
                                        title="View Full Profile"
                                      >
                                        <i className="fas fa-eye"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    
                    {/* Active Teachers Section */}
                    <div className="card shadow mt-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">Active Teachers</h6>
                      </div>
                      <div className="card-body">
                        {hiringRequests.filter(r => r.status === 'accepted').length === 0 ? (
                          <div className="text-center py-3">
                            <p className="text-muted">No active teachers</p>
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Teacher</th>
                                  <th>TRCN Status</th>
                                  <th>Child</th>
                                  <th>Subject</th>
                                  <th>Rate</th>
                                  <th>Status</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {hiringRequests
                                  .filter(r => r.status === 'accepted')
                                  .map((request, index) => {
                                    // Find teacher from teachers array to get TRCN status
                                    const teacher = teachers.find(t => t.id === request.teacherId);
                                    const trcnDisplay = getTRCNDisplay(teacher);
                                    
                                    return (
                                      <tr key={index}>
                                        <td>
                                          {teacher ? (
                                            <a 
                                              href={`/teacher-profile/${teacher.id}`} 
                                              target="_blank" 
                                              rel="noopener noreferrer"
                                              className="text-decoration-none text-primary"
                                            >
                                              {request.teacherName}
                                              <i className="fas fa-external-link-alt ms-1 fa-xs"></i>
                                            </a>
                                          ) : (
                                            request.teacherName
                                          )}
                                        </td>
                                        <td>
                                          <span className={`badge ${trcnDisplay.badgeClass}`}>
                                            {trcnDisplay.text}
                                          </span>
                                        </td>
                                        <td>{request.childName}</td>
                                        <td>{request.subject}</td>
                                        <td>₦{request.hourlyRate}/hour</td>
                                        <td>
                                          <span className="badge bg-success">{request.status}</span>
                                        </td>
                                        <td>
                                          <button 
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() => openPaymentModal(request)}
                                          >
                                            Pay Now
                                          </button>
                                          <button 
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() => handleCancelHiringRequest(request.id)}
                                          >
                                            Cancel
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Payments Tab */}
                {activeTab === 'payments' && (
                  <div>
                    <h5 className="font-weight-bold text-gray-800 mb-4">Payments & Invoices</h5>
                    
                    <div className="row">
                      <div className="col-md-8">
                        <div className="card shadow mb-4">
                          <div className="card-header">
                            <h6 className="m-0 font-weight-bold text-primary">Monthly Invoices</h6>
                          </div>
                          <div className="card-body">
                            {monthlyInvoices.length === 0 ? (
                              <div className="text-center py-3">
                                <p className="text-muted">No invoices yet</p>
                              </div>
                            ) : (
                              <div className="table-responsive">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Month</th>
                                      <th>Teacher</th>
                                      <th>Child</th>
                                      <th>Amount</th>
                                      <th>Status</th>
                                      <th>Due Date</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {monthlyInvoices.map((invoice, index) => (
                                      <tr key={index}>
                                        <td>{invoice.month}</td>
                                        <td>{invoice.teacherName}</td>
                                        <td>{invoice.childName}</td>
                                        <td>₦{invoice.amount?.toLocaleString()}</td>
                                        <td>
                                          <span className={`badge bg-${invoice.status === 'paid' ? 'success' : 'warning'}`}>
                                            {invoice.status}
                                          </span>
                                        </td>
                                        <td>{formatDate(invoice.dueDate)}</td>
                                        <td>
                                          {invoice.status === 'pending' && (
                                            <button 
                                              className="btn btn-sm btn-outline-primary"
                                              onClick={() => {
                                                setSelectedHiringRequest(invoice);
                                                setPaymentCalculation({
                                                  hourlyRate: invoice.hourlyRate || 0,
                                                  sessionsPerWeek: invoice.sessionsPerWeek || 0,
                                                  daysPerWeek: invoice.preferredDays?.length || 0,
                                                  sessionDuration: invoice.sessionDuration || 0,
                                                  estimatedMonthlyHours: 0,
                                                  estimatedMonthlyCost: 0,
                                                  teacherName: invoice.teacherName || '',
                                                  childName: invoice.childName || '',
                                                  subject: invoice.subject || ''
                                                });
                                                setShowPaymentModal(true);
                                              }}
                                            >
                                              Pay Now
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-4">
                        <div className="card shadow">
                          <div className="card-header bg-success text-white">
                            <h6 className="m-0 font-weight-bold">Payment Summary</h6>
                          </div>
                          <div className="card-body">
                            <div className="mb-3">
                              <h6 className="text-muted">Total Due</h6>
                              <h3 className="text-danger">
                                ₦{monthlyInvoices
                                  .filter(i => i.status === 'pending')
                                  .reduce((sum, i) => sum + (i.amount || 0), 0)
                                  .toLocaleString()}
                              </h3>
                            </div>
                            <div className="mb-3">
                              <h6 className="text-muted">Paid This Month</h6>
                              <h3 className="text-success">
                                ₦{monthlyInvoices
                                  .filter(i => i.status === 'paid')
                                  .reduce((sum, i) => sum + (i.amount || 0), 0)
                                  .toLocaleString()}
                              </h3>
                            </div>
                            <div className="d-grid gap-2">
                              <button 
                                className="btn btn-success"
                                onClick={() => {
                                  const totalDue = monthlyInvoices
                                    .filter(i => i.status === 'pending')
                                    .reduce((sum, i) => sum + (i.amount || 0), 0);
                                  
                                  if (totalDue > 0) {
                                    if (walletBalance >= totalDue) {
                                      if (window.confirm(`Pay ₦${totalDue.toLocaleString()} for all pending invoices?`)) {
                                        // Process bulk payment
                                        alert('Bulk payment feature coming soon!');
                                      }
                                    } else {
                                      alert(`Insufficient balance. You need ₦${totalDue.toLocaleString()} but have ₦${walletBalance.toLocaleString()}`);
                                      setShowFundingModal(true);
                                    }
                                  } else {
                                    alert('No pending invoices to pay');
                                  }
                                }}
                              >
                                <i className="fas fa-bolt me-2"></i>Pay All Pending
                              </button>
                              <button 
                                className="btn btn-outline-success"
                                onClick={() => setShowFundingModal(true)}
                              >
                                <i className="fas fa-plus me-2"></i>Fund Wallet
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* Transactions History */}
                    <div className="card shadow mt-4">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">Recent Transactions</h6>
                      </div>
                      <div className="card-body">
                        {transactions.length === 0 ? (
                          <div className="text-center py-3">
                            <p className="text-muted">No transactions yet</p>
                          </div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Type</th>
                                  <th>Description</th>
                                  <th>Amount</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {transactions.slice(0, 10).map((transaction, index) => (
                                  <tr key={index}>
                                    <td>{formatDate(transaction.timestamp)}</td>
                                    <td>
                                      <span className={`badge bg-${
                                        transaction.type === 'credit' ? 'success' : 
                                        transaction.type === 'debit' ? 'danger' : 'info'
                                      }`}>
                                        {transaction.type}
                                      </span>
                                    </td>
                                    <td>{transaction.description}</td>
                                    <td className={`text-${transaction.type === 'credit' ? 'success' : 'danger'}`}>
                                      {transaction.type === 'credit' ? '+' : '-'}₦{Math.abs(transaction.amount).toLocaleString()}
                                    </td>
                                    <td>
                                      <span className={`badge bg-${transaction.status === 'success' ? 'success' : 'warning'}`}>
                                        {transaction.status}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Exam Support Tab */}
                {activeTab === 'exam-support' && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h5 className="font-weight-bold text-gray-800">Exam Fee Support</h5>
                        <p className="text-muted mb-0">
                          Support students with their examination fees (WAEC, NECO, JAMB, etc.)
                        </p>
                      </div>
                      <button 
                        className="btn btn-danger"
                        onClick={() => setShowExamSupportModal(true)}
                      >
                        <i className="fas fa-graduation-cap me-2"></i>Support Exam Fees
                      </button>
                    </div>
                    
                    <div className="row mb-4">
                      <div className="col-md-3">
                        <div className="card bg-warning text-white shadow">
                          <div className="card-body">
                            <div className="text-center">
                              <i className="fas fa-graduation-cap fa-2x mb-3"></i>
                              <h4>{examFeeStats.totalSupported}</h4>
                              <p className="mb-0">Total Supported</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card bg-primary text-white shadow">
                          <div className="card-body">
                            <div className="text-center">
                              <i className="fas fa-university fa-2x mb-3"></i>
                              <h4>{examFeeStats.waecSupported}</h4>
                              <p className="mb-0">WAEC</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card bg-success text-white shadow">
                          <div className="card-body">
                            <div className="text-center">
                              <i className="fas fa-school fa-2x mb-3"></i>
                              <h4>{examFeeStats.necoSupported}</h4>
                              <p className="mb-0">NECO</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card bg-info text-white shadow">
                          <div className="card-body">
                            <div className="text-center">
                              <i className="fas fa-book fa-2x mb-3"></i>
                              <h4>{examFeeStats.jambSupported}</h4>
                              <p className="mb-0">JAMB</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="card shadow">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">Recent Exam Support</h6>
                      </div>
                      <div className="card-body">
                        {donationHistory.filter(d => d.type === 'exam_support').length === 0 ? (
                          <EmptyState
                            icon="fa-graduation-cap"
                            title="No Exam Support Yet"
                            message="Support students with their examination fees to help them achieve their academic goals"
                            actionText="Support Exam Fees"
                            onAction={() => setShowExamSupportModal(true)}
                          />
                        ) : (
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Student</th>
                                  <th>Exam Type</th>
                                  <th>Amount</th>
                                  <th>Message</th>
                                </tr>
                              </thead>
                              <tbody>
                                {donationHistory
                                  .filter(d => d.type === 'exam_support')
                                  .slice(0, 10)
                                  .map((donation, index) => (
                                    <tr key={index}>
                                      <td>{formatDate(donation.timestamp)}</td>
                                      <td>{donation.childName || 'Anonymous Student'}</td>
                                      <td>
                                        <span className="badge bg-info">{donation.examType || 'Exam'}</span>
                                      </td>
                                      <td className="text-success">₦{donation.amount?.toLocaleString()}</td>
                                      <td>
                                        <small className="text-muted">{donation.message || 'No message'}</small>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* General Support Tab */}
                {activeTab === 'support' && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <h5 className="font-weight-bold text-gray-800">Student Support</h5>
                        <p className="text-muted mb-0">
                          Support underprivileged students with their educational needs
                        </p>
                      </div>
                      <button 
                        className="btn btn-primary"
                        onClick={() => setShowSupportModal(true)}
                      >
                        <i className="fas fa-hands-helping me-2"></i>Support a Student
                      </button>
                    </div>
                    
                    <div className="row mb-4">
                      {childrenForSupport.slice(0, 6).map((child, index) => (
                        <div key={index} className="col-md-4 mb-4">
                          <div className="card h-100">
                            <div className="card-body text-center">
                              <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                                   style={{width: '80px', height: '80px'}}>
                                {child.firstName?.charAt(0) || 'S'}
                              </div>
                              <h6 className="font-weight-bold">{child.firstName} {child.lastName}</h6>
                              <p className="text-muted mb-2">{child.grade}</p>
                              <p className="text-muted small mb-3">{child.school}</p>
                              
                              <div className="mb-3">
                                <small className="text-muted d-block">
                                  <i className="fas fa-book me-1"></i>
                                  Needs support in: {child.supportNeeds?.join(', ') || 'General education'}
                                </small>
                              </div>
                              
                              <button 
                                className="btn btn-outline-primary btn-sm w-100"
                                onClick={() => {
  const currentCoins = wallet?.eduCoins || 0;


  setSupportForm(prev => ({
    ...prev,
    childId: child.id,
    amount: '50' // 👈 coins now, not ₦5000
  }));

  // 🚨 CHECK WALLET BEFORE OPENING
  if (currentCoins < Number(5)) {
    setShowBuyCoinsModal(true); // ✅ open buy modal
  } else {
    setShowSupportModal(true); // ✅ open support modal
  }
}}
                              >
                                Support This Student
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    <div className="card shadow">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">Your Support History</h6>
                      </div>
                      <div className="card-body">
                        {donationHistory.filter(d => d.type === 'student_support').length === 0 ? (
                          <EmptyState
                            icon="fa-hands-helping"
                            title="No Support History"
                            message="Your support can make a difference in a student's education"
                            actionText="Support a Student Now"
                            onAction={() => setShowSupportModal(true)}
                          />
                        ) : (
                          <div className="table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Student</th>
                                  <th>Amount</th>
                                  <th>Message</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {donationHistory
                                  .filter(d => d.type === 'student_support')
                                  .slice(0, 10)
                                  .map((donation, index) => (
                                    <tr key={index}>
                                      <td>{formatDate(donation.timestamp)}</td>
                                      <td>{donation.childName}</td>
                                      <td className="text-success">₦{donation.amount?.toLocaleString()}</td>
                                      <td>
                                        <small className="text-muted">{donation.message || 'No message'}</small>
                                      </td>
                                      <td>
                                        <span className={`badge bg-${donation.status === 'completed' ? 'success' : 'warning'}`}>
                                          {donation.status}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* History Tab */}
                {activeTab === 'history' && (
                  <div>
                    <h5 className="font-weight-bold text-gray-800 mb-4">Activity History</h5>
                    
                    <div className="row">
                      <div className="col-md-6">
                        <div className="card shadow mb-4">
                          <div className="card-header">
                            <h6 className="m-0 font-weight-bold text-primary">Hiring Requests</h6>
                          </div>
                          <div className="card-body">
                            {hiringRequests.length === 0 ? (
                              <div className="text-center py-3">
                                <p className="text-muted">No hiring requests yet</p>
                              </div>
                            ) : (
                              <div className="timeline">
                                {hiringRequests.map((request, index) => (
                                  <div key={index} className="timeline-item mb-3">
                                    <div className={`timeline-marker bg-${request.status === 'accepted' ? 'success' : request.status === 'pending' ? 'warning' : 'danger'}`}></div>
                                    <div className="timeline-content">
                                      <h6 className="font-weight-bold">{request.teacherName}</h6>
                                      <p className="text-sm mb-1">
                                        {request.subject} for {request.childName}
                                      </p>
                                      <div className="d-flex justify-content-between">
                                        <span className={`badge badge-${request.status === 'accepted' ? 'success' : request.status === 'pending' ? 'warning' : 'danger'}`}>
                                          {request.status}
                                        </span>
                                        <small className="text-muted">
                                          {formatDate(request.requestedDate)}
                                        </small>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="card shadow mb-4">
                          <div className="card-header">
                            <h6 className="m-0 font-weight-bold text-primary">Recent Transactions</h6>
                          </div>
                          <div className="card-body">
                            {transactions.length === 0 ? (
                              <div className="text-center py-3">
                                <p className="text-muted">No transactions yet</p>
                              </div>
                            ) : (
                              <div className="list-group list-group-flush">
                                {transactions.slice(0, 5).map((transaction, index) => (
                                  <div key={index} className="list-group-item">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div>
                                        <h6 className="mb-0">{transaction.description}</h6>
                                        <small className="text-muted">{formatDate(transaction.timestamp)}</small>
                                      </div>
                                      <span className={`text-${transaction.type === 'credit' ? 'success' : 'danger'}`}>
                                        {transaction.type === 'credit' ? '+' : '-'}₦{Math.abs(transaction.amount).toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="card shadow">
                      <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">All Children</h6>
                      </div>
                      <div className="card-body">
                        {children.length === 0 ? (
                          <div className="text-center py-3">
                            <p className="text-muted">No children registered yet</p>
                          </div>
                        ) : (
                          <div className="row">
                            {children.map((child, index) => (
                              <div key={index} className="col-md-4 mb-4">
                                <div className="card h-100">
                                  <div className="card-body">
                                    <div className="text-center mb-3">
                                      <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto"
                                           style={{width: '60px', height: '60px'}}>
                                        {child.firstName?.charAt(0) || 'C'}
                                      </div>
                                    </div>
                                    <h6 className="text-center font-weight-bold">{child.firstName} {child.lastName}</h6>
                                    <p className="text-center text-muted mb-2">{child.grade}</p>
                                    <div className="text-center">
                                      <small className="text-muted d-block">
                                        <i className="fas fa-school me-1"></i>
                                        {child.school || 'Not specified'}
                                      </small>
                                      <small className="text-muted d-block">
                                        <i className="fas fa-calendar me-1"></i>
                                        Registered: {formatDate(child.registrationDate)}
                                      </small>
                                    </div>
                                    <div className="d-flex justify-content-center gap-2 mt-3">
                                      <button 
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={() => openLearningAnalyticsModal(child)}
                                      >
                                        Analytics
                                      </button>
                                      <button 
                                        className="btn btn-sm btn-outline-dark"
                                        onClick={() => openAIPredictionModal(child)}
                                      >
                                        AI Prediction
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODALS - All remain exactly the same as in your original code */}
      {/* I'll include them all but note they're identical to your original */}

      {/* Child Registration Modal */}
      {showChildModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Register Child</h5>
                <button type="button" className="btn-close" onClick={() => setShowChildModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleRegisterChild}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">First Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={childForm.firstName}
                        onChange={(e) => setChildForm({...childForm, firstName: e.target.value})}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Last Name *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={childForm.lastName}
                        onChange={(e) => setChildForm({...childForm, lastName: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Grade *</label>
                      <select
                        className="form-select"
                        value={childForm.grade}
                        onChange={(e) => setChildForm({...childForm, grade: e.target.value})}
                        required
                      >
                        <option value="">Select Grade</option>
                        <option value="Primary 1">Primary 1</option>
                        <option value="Primary 2">Primary 2</option>
                        <option value="Primary 3">Primary 3</option>
                        <option value="Primary 4">Primary 4</option>
                        <option value="Primary 5">Primary 5</option>
                        <option value="Primary 6">Primary 6</option>
                        <option value="JSS 1">JSS 1</option>
                        <option value="JSS 2">JSS 2</option>
                        <option value="JSS 3">JSS 3</option>
                        <option value="SSS 1">SSS 1</option>
                        <option value="SSS 2">SSS 2</option>
                        <option value="SSS 3">SSS 3</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Learning Style</label>
                      <select
                        className="form-select"
                        value={childForm.learningStyle}
                        onChange={(e) => setChildForm({...childForm, learningStyle: e.target.value})}
                      >
                        <option value="visual">Visual</option>
                        <option value="auditory">Auditory</option>
                        <option value="kinesthetic">Kinesthetic</option>
                        <option value="reading_writing">Reading/Writing</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Subjects of Interest</label>
                    <div className="row">
                      {['Mathematics', 'English', 'Science', 'Social Studies', 'Arts', 'Music', 'Physical Education'].map(subject => (
                        <div key={subject} className="col-6 col-md-4 mb-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={childForm.subjects?.includes(subject) || false}
                              onChange={(e) => {
                                const subjects = childForm.subjects || [];
                                if (e.target.checked) {
                                  setChildForm({...childForm, subjects: [...subjects, subject]});
                                } else {
                                  setChildForm({...childForm, subjects: subjects.filter(s => s !== subject)});
                                }
                              }}
                            />
                            <label className="form-check-label">{subject}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Learning Goals</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={childForm.learningGoals}
                      onChange={(e) => setChildForm({...childForm, learningGoals: e.target.value})}
                      placeholder="What are your child's learning objectives?"
                    />
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowChildModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Registering...' : 'Register Child'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hire Teacher Modal */}
      {showHireModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Hire Teacher</h5>
                <button type="button" className="btn-close" onClick={() => setShowHireModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleHireTeacher}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Child *</label>
                      <select
                        className="form-select"
                        value={hireForm.childId}
                        onChange={(e) => setHireForm({...hireForm, childId: e.target.value})}
                        required
                      >
                        <option value="">Choose a child</option>
                        {children.map((child, index) => (
                          <option key={child.id} value={child.id}>
                            {child.firstName} {child.lastName} - {child.grade}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Teacher *</label>
                      <select
                        className="form-select"
                        value={hireForm.teacherId}
                        onChange={(e) => {
                          const teacher = teachers.find(t => t.id === e.target.value);
                          setHireForm({
                            ...hireForm,
                            teacherId: e.target.value,
                            hourlyRate: teacher?.hourlyRate || ''
                          });
                        }}
                        required
                      >
                        <option value="">Choose a teacher</option>
                        {teachers.map((teacher, index) => (
                          <option key={teacher.id} value={teacher.id}>
                            {teacher.firstName} {teacher.lastName} - ₦{teacher.hourlyRate}/hour
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Subject *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={hireForm.subject}
                        onChange={(e) => setHireForm({...hireForm, subject: e.target.value})}
                        required
                        placeholder="e.g., Mathematics"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Hourly Rate (₦) *</label>
                      <input
                        type="number"
                        className="form-control"
                        value={hireForm.hourlyRate}
                        onChange={(e) => setHireForm({...hireForm, hourlyRate: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Session Type</label>
                      <select
                        className="form-select"
                        value={hireForm.sessionType}
                        onChange={(e) => setHireForm({...hireForm, sessionType: e.target.value})}
                      >
                        <option value="online">Online</option>
                        <option value="in-person">In-person</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Session Duration (minutes)</label>
                      <select
                        className="form-select"
                        value={hireForm.sessionDuration}
                        onChange={(e) => setHireForm({...hireForm, sessionDuration: e.target.value})}
                      >
                        <option value="60">60 minutes</option>
                        <option value="90">90 minutes</option>
                        <option value="120">120 minutes</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Sessions Per Week</label>
                      <input
                        type="number"
                        className="form-control"
                        value={hireForm.sessionsPerWeek}
                        onChange={(e) => setHireForm({...hireForm, sessionsPerWeek: e.target.value})}
                        min="1"
                        max="7"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Preferred Time</label>
                      <select
                        className="form-select"
                        value={hireForm.preferredTime}
                        onChange={(e) => setHireForm({...hireForm, preferredTime: e.target.value})}
                      >
                        <option value="morning">Morning</option>
                        <option value="afternoon">Afternoon</option>
                        <option value="evening">Evening</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Preferred Days</label>
                    <div className="row">
                      {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(day => (
                        <div key={day} className="col-6 col-md-4 mb-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={hireForm.preferredDays?.includes(day) || false}
                              onChange={(e) => {
                                const days = hireForm.preferredDays || [];
                                if (e.target.checked) {
                                  setHireForm({...hireForm, preferredDays: [...days, day]});
                                } else {
                                  setHireForm({...hireForm, preferredDays: days.filter(d => d !== day)});
                                }
                              }}
                            />
                            <label className="form-check-label">{day}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowHireModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Processing...' : 'Submit Request'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {showPaymentModal && selectedHiringRequest && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Process Payment</h5>
                <button type="button" className="btn-close" onClick={() => setShowPaymentModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  You are about to make payment for {selectedHiringRequest.teacherName}'s services for {selectedHiringRequest.childName}
                </div>
                
                <div className="row mb-4">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h6 className="card-title">Payment Details</h6>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td>Teacher:</td>
                              <td>{selectedHiringRequest.teacherName}</td>
                            </tr>
                            <tr>
                              <td>Child:</td>
                              <td>{selectedHiringRequest.childName}</td>
                            </tr>
                            <tr>
                              <td>Subject:</td>
                              <td>{selectedHiringRequest.subject}</td>
                            </tr>
                            <tr>
                              <td>Hourly Rate:</td>
                              <td>₦{selectedHiringRequest.hourlyRate}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <h6 className="card-title">Payment Calculator</h6>
                        <div className="mb-3">
                          <label className="form-label">Sessions per Week</label>
                          <input
                            type="number"
                            className="form-control"
                            value={paymentCalculation.sessionsPerWeek}
                            onChange={(e) => setPaymentCalculation({
                              ...paymentCalculation,
                              sessionsPerWeek: e.target.value,
                              estimatedMonthlyHours: 0,
                              estimatedMonthlyCost: 0
                            })}
                            min="1"
                            max="7"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Session Duration (minutes)</label>
                          <select
                            className="form-select"
                            value={paymentCalculation.sessionDuration}
                            onChange={(e) => setPaymentCalculation({
                              ...paymentCalculation,
                              sessionDuration: e.target.value,
                              estimatedMonthlyHours: 0,
                              estimatedMonthlyCost: 0
                            })}
                          >
                            <option value="60">60 minutes</option>
                            <option value="90">90 minutes</option>
                            <option value="120">120 minutes</option>
                          </select>
                        </div>
                        <button 
                          className="btn btn-outline-primary w-100"
                          onClick={handleCalculateMonthlyPayment}
                        >
                          Calculate Monthly Cost
                        </button>
                        
                        {paymentCalculation.estimatedMonthlyCost > 0 && (
                          <div className="alert alert-success mt-3">
                            <h6>Estimated Monthly Cost</h6>
                            <h4>₦{paymentCalculation.estimatedMonthlyCost.toLocaleString()}</h4>
                            <small className="text-muted">
                              Based on {paymentCalculation.estimatedMonthlyHours} hours per month
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Your current wallet balance: ₦{walletBalance.toLocaleString()}
                </div>
                
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowPaymentModal(false)}>
                    Cancel
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={() => handleProcessPayment(
                      selectedHiringRequest.id,
                      paymentCalculation.estimatedMonthlyCost || selectedHiringRequest.estimatedMonthlyCost || 0,
                      selectedHiringRequest.teacherId,
                      selectedHiringRequest.childId,
                      selectedHiringRequest.subject
                    )}
                    disabled={loading || walletBalance < (paymentCalculation.estimatedMonthlyCost || selectedHiringRequest.estimatedMonthlyCost || 0)}
                  >
                    {loading ? 'Processing...' : `Pay ₦${(paymentCalculation.estimatedMonthlyCost || selectedHiringRequest.estimatedMonthlyCost || 0).toLocaleString()}`}
                  </button>
                  {walletBalance < (paymentCalculation.estimatedMonthlyCost || selectedHiringRequest.estimatedMonthlyCost || 0) && (
                    <button 
                      type="button" 
                      className="btn btn-warning"
                      onClick={() => {
                        setShowPaymentModal(false);
                        setShowFundingModal(true);
                      }}
                    >
                      Fund Wallet
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Funding Modal */}
      {showFundingModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Fund Your Wallet</h5>
                <button type="button" className="btn-close" onClick={() => setShowFundingModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleFundWalletViaPaystack}>
                  <div className="mb-3">
                    <label className="form-label">Amount (₦) *</label>
                    <input
                      type="number"
                      className="form-control"
                      value={fundingForm.amount}
                      onChange={(e) => setFundingForm({...fundingForm, amount: e.target.value})}
                      required
                      min="100"
                      placeholder="Minimum: ₦100"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Payment Method</label>
                    <select
                      className="form-select"
                      value={fundingForm.paymentMethod}
                      onChange={(e) => setFundingForm({...fundingForm, paymentMethod: e.target.value})}
                    >
                      <option value="bank_transfer">Bank Transfer</option>
                      <option value="card">Card Payment</option>
                    </select>
                  </div>
                  
                  {!parentEmail && (
                    <div className="mb-3">
                      <label className="form-label">Email Address *</label>
                      <input
                        type="email"
                        className="form-control"
                        value={paymentForm.email}
                        onChange={(e) => setPaymentForm({...paymentForm, email: e.target.value})}
                        required
                      />
                    </div>
                  )}
                  
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    You will be redirected to Paystack to complete the payment securely
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowFundingModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Proceed to Payment
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Buy EduCoins Modal */}
      {showBuyCoinsModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Buy EduCoins</h5>
                <button type="button" className="btn-close" onClick={() => setShowBuyCoinsModal(false)}></button>
              </div>
              <div className="modal-body">
                <p className="text-muted">You need more EduCoins to continue. Enter an amount in naira to purchase coins.</p>
                <input
                  type="number"
                  className="form-control mb-3"
                  placeholder="Enter amount (₦)"
                  value={coinAmount}
                  onChange={(e) => setCoinAmount(e.target.value)}
                />
                <div className="d-flex gap-2 justify-content-end">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowBuyCoinsModal(false)}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleBuyCoins}>
                    Buy Coins
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Support Modal */}
      {showSupportModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Support a Student</h5>
                <button type="button" className="btn-close" onClick={() => setShowSupportModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSupportStudent}>
                  <div className="mb-3">
                    <label className="form-label">Select Student *</label>
                    <select
                      className="form-select"
                      value={supportForm.childId}
                      onChange={(e) => setSupportForm({...supportForm, childId: e.target.value})}
                      required
                    >
                      <option value="">Choose a student</option>
                      {childrenForSupport.map((child, index) => (
                        <option key={index} value={child.id}>
                          {child.firstName} {child.lastName} - {child.grade}
                        </option>
                      ))}
                    </select>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Amount (₦) *</label>
                    <input
                      type="number"
                      className="form-control"
                      value={supportForm.amount}
                      onChange={(e) => setSupportForm({...supportForm, amount: e.target.value})}
                      required
                      min="100"
                      placeholder="Minimum: ₦100"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Message (Optional)</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={supportForm.message}
                      onChange={(e) => setSupportForm({...supportForm, message: e.target.value})}
                      placeholder="Add an encouraging message for the student..."
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Payment Method</label>
                    <select
                      className="form-select"
                      value={supportForm.paymentMethod}
                      onChange={(e) => setSupportForm({...supportForm, paymentMethod: e.target.value})}
                    >
                      <option value="wallet">Wallet Balance</option>
                      <option value="card">Card Payment</option>
                    </select>
                  </div>
                  
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    Your support will be directly transferred to the student's educational account
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowSupportModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Processing...' : 'Send Support'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Exam Support Modal */}
      {showExamSupportModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Support Exam Fees</h5>
                <button type="button" className="btn-close" onClick={() => setShowExamSupportModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSupportExamFee}>
                  <div className="mb-3">
                    <label className="form-label">Exam Type *</label>
                    <select
                      className="form-select"
                      value={examSupportForm.supportType}
                      onChange={(e) => setExamSupportForm({...examSupportForm, supportType: e.target.value})}
                      required
                    >
                      <option value="waec">WAEC</option>
                      <option value="neco">NECO</option>
                      <option value="jamb">JAMB</option>
                      <option value="other">Other Exams</option>
                    </select>
                  </div>
                  
                  {examSupportForm.supportType === 'other' && (
                    <div className="mb-3">
                      <label className="form-label">Exam Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={examSupportForm.otherDescription}
                        onChange={(e) => setExamSupportForm({...examSupportForm, otherDescription: e.target.value})}
                        placeholder="e.g., BECE, Common Entrance, etc."
                      />
                    </div>
                  )}
                  
                  <div className="mb-3">
                    <label className="form-label">Number of Students</label>
                    <input
                      type="number"
                      className="form-control"
                      value={examSupportForm.numberOfStudents}
                      onChange={(e) => setExamSupportForm({...examSupportForm, numberOfStudents: e.target.value})}
                      min="1"
                      max="10"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Custom Amount (Optional)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={examSupportForm.customAmount}
                      onChange={(e) => setExamSupportForm({...examSupportForm, customAmount: e.target.value})}
                      placeholder="Leave empty for standard exam fee"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Message (Optional)</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={examSupportForm.message}
                      onChange={(e) => setExamSupportForm({...examSupportForm, message: e.target.value})}
                      placeholder="Add an encouraging message for the students..."
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Payment Method</label>
                    <select
                      className="form-select"
                      value={examSupportForm.paymentMethod}
                      onChange={(e) => setExamSupportForm({...examSupportForm, paymentMethod: e.target.value})}
                    >
                      <option value="wallet">Wallet Balance</option>
                      <option value="card">Card Payment</option>
                    </select>
                  </div>
                  
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    Standard exam fees: WAEC (₦18,000), NECO (₦15,000), JAMB (₦6,500)
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowExamSupportModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                      {loading ? 'Processing...' : 'Support Exam Fees'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* AI Prediction Modal */}
      {showAIPredictionModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-dark text-white">
                <h5 className="modal-title">
                  <i className="fas fa-robot me-2"></i>Generate AI Prediction
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowAIPredictionModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={(e) => { e.preventDefault(); handleGenerateAiPrediction(); }}>
                  <div className="mb-4">
                    <div className="alert alert-info">
                      <i className="fas fa-info-circle me-2"></i>
                      Our AI will analyze your child's learning patterns, teacher observations, and performance history to predict future performance.
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Child *</label>
                      <select
                        className="form-select"
                        value={aiPredictionForm.childId}
                        onChange={(e) => setAiPredictionForm({...aiPredictionForm, childId: e.target.value})}
                        required
                      >
                        <option value="">Choose a child</option>
                        {children.map((child) => (
                          <option key={child.id} value={child.id}>
                            {child.firstName} {child.lastName} - {child.grade}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Prediction Timeframe</label>
                      <select
                        className="form-select"
                        value={aiPredictionForm.timeframe}
                        onChange={(e) => setAiPredictionForm({...aiPredictionForm, timeframe: e.target.value})}
                      >
                        <option value="1_month">1 Month</option>
                        <option value="3_months">3 Months</option>
                        <option value="6_months">6 Months</option>
                        <option value="1_year">1 Year</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={aiPredictionForm.includeObservations}
                          onChange={(e) => setAiPredictionForm({...aiPredictionForm, includeObservations: e.target.checked})}
                        />
                        <label className="form-check-label">
                          Include Teacher Observations
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={aiPredictionForm.includePerformanceHistory}
                          onChange={(e) => setAiPredictionForm({...aiPredictionForm, includePerformanceHistory: e.target.checked})}
                        />
                        <label className="form-check-label">
                          Include Performance History
                        </label>
                      </div>
                    </div>
                  </div>
                  
                  <div className="alert alert-warning">
                    <small>
                      <i className="fas fa-exclamation-triangle me-1"></i>
                      AI predictions are based on available data and should be used as guidance, not absolute certainty.
                    </small>
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowAIPredictionModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-dark" disabled={generatingPrediction}>
                      {generatingPrediction ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Generating...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-robot me-2"></i>
                          Generate AI Prediction
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Study Plan Modal */}
      {showStudyPlanModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-secondary text-white">
                <h5 className="modal-title">
                  <i className="fas fa-calendar-alt me-2"></i>Generate Study Plan
                </h5>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShowStudyPlanModal(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={(e) => { e.preventDefault(); handleGenerateStudyPlan(); }}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Child *</label>
                      <select
                        className="form-select"
                        value={studyPlanForm.childId}
                        onChange={(e) => setStudyPlanForm({...studyPlanForm, childId: e.target.value})}
                        required
                      >
                        <option value="">Choose a child</option>
                        {children.map((child) => (
                          <option key={child.id} value={child.id}>
                            {child.firstName} {child.lastName} - {child.grade}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Subject *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={studyPlanForm.subject}
                        onChange={(e) => setStudyPlanForm({...studyPlanForm, subject: e.target.value})}
                        required
                        placeholder="e.g., Mathematics"
                      />
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Time Available per Week</label>
                      <select
                        className="form-select"
                        value={studyPlanForm.timeAvailable}
                        onChange={(e) => setStudyPlanForm({...studyPlanForm, timeAvailable: e.target.value})}
                      >
                        <option value="3 hours per week">3 hours per week</option>
                        <option value="5 hours per week">5 hours per week</option>
                        <option value="7 hours per week">7 hours per week</option>
                        <option value="10 hours per week">10 hours per week</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Plan Duration</label>
                      <select
                        className="form-select"
                        value={studyPlanForm.duration}
                        onChange={(e) => setStudyPlanForm({...studyPlanForm, duration: e.target.value})}
                      >
                        <option value="2_weeks">2 Weeks</option>
                        <option value="4_weeks">4 Weeks</option>
                        <option value="8_weeks">8 Weeks</option>
                        <option value="12_weeks">12 Weeks</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Specific Goals (Optional)</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={studyPlanForm.goals}
                      onChange={(e) => setStudyPlanForm({...studyPlanForm, goals: e.target.value})}
                      placeholder="Enter specific learning goals, separated by commas"
                    />
                    <small className="text-muted">e.g., Improve algebra skills, Master fractions, Score 90% on next test</small>
                  </div>
                  
                  <div className="alert alert-info">
                    <i className="fas fa-lightbulb me-2"></i>
                    Our AI will create a personalized study plan based on your child's learning style and the selected subject.
                  </div>
                  
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowStudyPlanModal(false)}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-secondary" disabled={generatingStudyPlan}>
                      {generatingStudyPlan ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Generating...
                        </>
                      ) : (
                        <>
                          <i className="fas fa-calendar-alt me-2"></i>
                          Generate Study Plan
                        </>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Learning Analytics Modal */}
      {showLearningAnalyticsModal && selectedChildForAnalytics && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-chart-line me-2"></i>
                  Learning Analytics - {selectedChildForAnalytics.firstName} {selectedChildForAnalytics.lastName}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowLearningAnalyticsModal(false)}></button>
              </div>
              <div className="modal-body">
                {loading ? (
                  <div className="text-center py-5">
                    <LoadingSpinner />
                    <p className="mt-3">Loading learning profile...</p>
                  </div>
                ) : childLearningProfile ? (
                  <ChildLearningAnalytics
                    child={selectedChildForAnalytics}
                    profile={childLearningProfile}
                    detailedView={true}
                    onGeneratePrediction={() => {
                      setShowLearningAnalyticsModal(false);
                      openAIPredictionModal(selectedChildForAnalytics);
                    }}
                    onGenerateStudyPlan={() => {
                      setShowLearningAnalyticsModal(false);
                      openStudyPlanModal(selectedChildForAnalytics);
                    }}
                    onClose={() => setShowLearningAnalyticsModal(false)}
                  />
                ) : (
                  <EmptyState
                    icon="fa-chart-line"
                    title="No Learning Data Available"
                    message="Start by having teachers add observations and assessments for this child"
                    actionText="Request Teacher Assessment"
                    onAction={() => {
                      alert('Feature coming soon!');
                    }}
                  />
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowLearningAnalyticsModal(false)}>
                  Close
                </button>
                <button 
                  type="button" 
                  className="btn btn-dark"
                  onClick={() => {
                    setShowLearningAnalyticsModal(false);
                    openAIPredictionModal(selectedChildForAnalytics);
                  }}
                >
                  <i className="fas fa-robot me-2"></i>Generate AI Prediction
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Wallet Modal */}
      {showWalletModal && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Wallet Management</h5>
                <button type="button" className="btn-close" onClick={() => setShowWalletModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="text-center mb-4">
                  <div className="display-4 text-success mb-2">₦{walletBalance.toLocaleString()}</div>
                  <p className="text-muted">Available Balance</p>
                </div>
                
                <div className="row mb-4">
                  <div className="col-6">
                    <div className="card text-center">
                      <div className="card-body">
                        <div className="text-warning">
                          <i className="fas fa-coins fa-2x mb-3"></i>
                          <h5>{tokenBalance}</h5>
                          <p className="mb-0">EDU Coins</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="card text-center">
                      <div className="card-body">
                        <div className="text-primary">
                          <i className="fas fa-gift fa-2x mb-3"></i>
                          <h5>0</h5>
                          <p className="mb-0">Rewards</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="d-grid gap-2">
                  <button 
                    className="btn btn-success"
                    onClick={() => {
                      setShowWalletModal(false);
                      setShowFundingModal(true);
                    }}
                  >
                    <i className="fas fa-plus me-2"></i>Add Funds
                  </button>
                  <button 
                    className="btn btn-outline-primary"
                    onClick={() => {
                      alert('Withdrawal feature coming soon!');
                    }}
                  >
                    <i className="fas fa-money-bill-wave me-2"></i>Withdraw Funds
                  </button>
                  <button 
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      setActiveTab('payments');
                      setShowWalletModal(false);
                    }}
                  >
                    <i className="fas fa-history me-2"></i>View Transaction History
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Parent;